(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6077],{

/***/ 92222:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var isArray = __webpack_require__(43157);
var isObject = __webpack_require__(70111);
var toObject = __webpack_require__(47908);
var toLength = __webpack_require__(17466);
var createProperty = __webpack_require__(86135);
var arraySpeciesCreate = __webpack_require__(65417);
var arrayMethodHasSpeciesSupport = __webpack_require__(81194);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 5212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var $some = (__webpack_require__(42092).some);
var arrayMethodIsStrict = __webpack_require__(9341);

var STRICT_METHOD = arrayMethodIsStrict('some');

// `Array.prototype.some` method
// https://tc39.es/ecma262/#sec-array.prototype.some
$({ target: 'Array', proto: true, forced: !STRICT_METHOD }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 5735:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(82109);
var fails = __webpack_require__(47293);
var toObject = __webpack_require__(47908);
var toPrimitive = __webpack_require__(57593);

var FORCED = fails(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
});

// `Date.prototype.toJSON` method
// https://tc39.es/ecma262/#sec-date.prototype.tojson
$({ target: 'Date', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O, 'number');
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),

/***/ 38862:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var getBuiltIn = __webpack_require__(35005);
var fails = __webpack_require__(47293);

var $stringify = getBuiltIn('JSON', 'stringify');
var re = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var fix = function (match, offset, string) {
  var prev = string.charAt(offset - 1);
  var next = string.charAt(offset + 1);
  if ((low.test(match) && !hi.test(next)) || (hi.test(match) && !low.test(prev))) {
    return '\\u' + match.charCodeAt(0).toString(16);
  } return match;
};

var FORCED = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  // https://github.com/tc39/proposal-well-formed-stringify
  $({ target: 'JSON', stat: true, forced: FORCED }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var result = $stringify.apply(null, arguments);
      return typeof result == 'string' ? result.replace(re, fix) : result;
    }
  });
}


/***/ }),

/***/ 44363:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);

// `Number.MAX_SAFE_INTEGER` constant
// https://tc39.es/ecma262/#sec-number.max_safe_integer
$({ target: 'Number', stat: true }, {
  MAX_SAFE_INTEGER: 0x1FFFFFFFFFFFFF
});


/***/ }),

/***/ 4723:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__(27007);
var anObject = __webpack_require__(19670);
var toLength = __webpack_require__(17466);
var toString = __webpack_require__(41340);
var requireObjectCoercible = __webpack_require__(84488);
var advanceStringIndex = __webpack_require__(31530);
var regExpExec = __webpack_require__(97651);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 41874:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-iterator-helpers
var $ = __webpack_require__(82109);
var iterate = __webpack_require__(20408);
var aFunction = __webpack_require__(13099);
var anObject = __webpack_require__(19670);

$({ target: 'Iterator', proto: true, real: true }, {
  some: function some(fn) {
    anObject(this);
    aFunction(fn);
    return iterate(this, function (value, stop) {
      if (fn(value)) return stop();
    }, { IS_ITERATOR: true, INTERRUPTED: true }).stopped;
  }
});


/***/ }),

/***/ 32564:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var $ = __webpack_require__(82109);
var global = __webpack_require__(17854);
var userAgent = __webpack_require__(88113);

var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
$({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global.setInterval)
});


/***/ }),

/***/ 87028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AddressInput_AddressInput; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(89554);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(30489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(68304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(88674);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(32023);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(15306);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(2490);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.filter.js
var esnext_iterator_filter = __webpack_require__(59849);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.for-each.js
var esnext_iterator_for_each = __webpack_require__(34514);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/__generated__/icons/Search.js
var Search = __webpack_require__(86048);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.some.js
var es_array_some = __webpack_require__(5212);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.some.js
var esnext_iterator_some = __webpack_require__(41874);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(96649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-json.js
var es_date_to_json = __webpack_require__(5735);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(96078);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__(38862);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-properties.js
var es_object_define_properties = __webpack_require__(33321);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(32564);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
// EXTERNAL MODULE: ./node_modules/@opendoor/observability/dist/observability-slim.mjs
var observability_slim = __webpack_require__(74593);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/globals.mjs + 2 modules
var globals = __webpack_require__(47254);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/api.mjs

function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function cov_138knjrxo4() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/api.ts";
    var hash = "ff4b1abb905f603a0b34bacb9a52427b094d7cb2";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/api.ts",
        statementMap: {
            "0": {
                start: {
                    line: 7,
                    column: 19
                },
                end: {
                    line: 7,
                    column: 33
                }
            },
            "1": {
                start: {
                    line: 9,
                    column: 24
                },
                end: {
                    line: 9,
                    column: 84
                }
            },
            "2": {
                start: {
                    line: 14,
                    column: 20
                },
                end: {
                    line: 22,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 23,
                    column: 19
                },
                end: {
                    line: 23,
                    column: 42
                }
            },
            "4": {
                start: {
                    line: 35,
                    column: 23
                },
                end: {
                    line: 48,
                    column: 1
                }
            },
            "5": {
                start: {
                    line: 36,
                    column: 18
                },
                end: {
                    line: 36,
                    column: 38
                }
            },
            "6": {
                start: {
                    line: 37,
                    column: 21
                },
                end: {
                    line: 37,
                    column: 46
                }
            },
            "7": {
                start: {
                    line: 39,
                    column: 2
                },
                end: {
                    line: 47,
                    column: 3
                }
            },
            "8": {
                start: {
                    line: 40,
                    column: 4
                },
                end: {
                    line: 40,
                    column: 37
                }
            },
            "9": {
                start: {
                    line: 42,
                    column: 4
                },
                end: {
                    line: 42,
                    column: 31
                }
            },
            "10": {
                start: {
                    line: 42,
                    column: 21
                },
                end: {
                    line: 42,
                    column: 31
                }
            },
            "11": {
                start: {
                    line: 45,
                    column: 4
                },
                end: {
                    line: 45,
                    column: 56
                }
            },
            "12": {
                start: {
                    line: 45,
                    column: 29
                },
                end: {
                    line: 45,
                    column: 54
                }
            },
            "13": {
                start: {
                    line: 46,
                    column: 4
                },
                end: {
                    line: 46,
                    column: 75
                }
            },
            "14": {
                start: {
                    line: 50,
                    column: 15
                },
                end: {
                    line: 50,
                    column: 52
                }
            },
            "15": {
                start: {
                    line: 53,
                    column: 2
                },
                end: {
                    line: 55,
                    column: 3
                }
            },
            "16": {
                start: {
                    line: 54,
                    column: 4
                },
                end: {
                    line: 54,
                    column: 22
                }
            },
            "17": {
                start: {
                    line: 56,
                    column: 2
                },
                end: {
                    line: 59,
                    column: 5
                }
            },
            "18": {
                start: {
                    line: 57,
                    column: 4
                },
                end: {
                    line: 57,
                    column: 38
                }
            },
            "19": {
                start: {
                    line: 58,
                    column: 4
                },
                end: {
                    line: 58,
                    column: 69
                }
            },
            "20": {
                start: {
                    line: 60,
                    column: 2
                },
                end: {
                    line: 60,
                    column: 19
                }
            },
            "21": {
                start: {
                    line: 70,
                    column: 2
                },
                end: {
                    line: 83,
                    column: 5
                }
            },
            "22": {
                start: {
                    line: 87,
                    column: 2
                },
                end: {
                    line: 109,
                    column: 48
                }
            },
            "23": {
                start: {
                    line: 109,
                    column: 18
                },
                end: {
                    line: 109,
                    column: 46
                }
            },
            "24": {
                start: {
                    line: 113,
                    column: 2
                },
                end: {
                    line: 148,
                    column: 48
                }
            },
            "25": {
                start: {
                    line: 148,
                    column: 18
                },
                end: {
                    line: 148,
                    column: 46
                }
            },
            "26": {
                start: {
                    line: 171,
                    column: 19
                },
                end: {
                    line: 182,
                    column: 3
                }
            },
            "27": {
                start: {
                    line: 184,
                    column: 2
                },
                end: {
                    line: 226,
                    column: 7
                }
            },
            "28": {
                start: {
                    line: 213,
                    column: 6
                },
                end: {
                    line: 216,
                    column: 7
                }
            },
            "29": {
                start: {
                    line: 214,
                    column: 26
                },
                end: {
                    line: 214,
                    column: 47
                }
            },
            "30": {
                start: {
                    line: 215,
                    column: 8
                },
                end: {
                    line: 215,
                    column: 65
                }
            },
            "31": {
                start: {
                    line: 217,
                    column: 21
                },
                end: {
                    line: 217,
                    column: 42
                }
            },
            "32": {
                start: {
                    line: 218,
                    column: 6
                },
                end: {
                    line: 220,
                    column: 7
                }
            },
            "33": {
                start: {
                    line: 219,
                    column: 8
                },
                end: {
                    line: 219,
                    column: 76
                }
            },
            "34": {
                start: {
                    line: 221,
                    column: 6
                },
                end: {
                    line: 221,
                    column: 20
                }
            },
            "35": {
                start: {
                    line: 224,
                    column: 6
                },
                end: {
                    line: 224,
                    column: 35
                }
            },
            "36": {
                start: {
                    line: 225,
                    column: 6
                },
                end: {
                    line: 225,
                    column: 14
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 35,
                        column: 23
                    },
                    end: {
                        line: 35,
                        column: 24
                    }
                },
                loc: {
                    start: {
                        line: 35,
                        column: 97
                    },
                    end: {
                        line: 48,
                        column: 1
                    }
                },
                line: 35
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 45,
                        column: 22
                    },
                    end: {
                        line: 45,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 45,
                        column: 29
                    },
                    end: {
                        line: 45,
                        column: 54
                    }
                },
                line: 45
            },
            "2": {
                name: "handleResponse",
                decl: {
                    start: {
                        line: 52,
                        column: 9
                    },
                    end: {
                        line: 52,
                        column: 23
                    }
                },
                loc: {
                    start: {
                        line: 52,
                        column: 39
                    },
                    end: {
                        line: 61,
                        column: 1
                    }
                },
                line: 52
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 56,
                        column: 21
                    },
                    end: {
                        line: 56,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 56,
                        column: 32
                    },
                    end: {
                        line: 59,
                        column: 3
                    }
                },
                line: 56
            },
            "4": {
                name: "doBFFPost",
                decl: {
                    start: {
                        line: 65,
                        column: 9
                    },
                    end: {
                        line: 65,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 21
                    },
                    end: {
                        line: 84,
                        column: 1
                    }
                },
                line: 69
            },
            "5": {
                name: "listUnits",
                decl: {
                    start: {
                        line: 86,
                        column: 16
                    },
                    end: {
                        line: 86,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 86,
                        column: 47
                    },
                    end: {
                        line: 110,
                        column: 1
                    }
                },
                line: 86
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 109,
                        column: 11
                    },
                    end: {
                        line: 109,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 109,
                        column: 18
                    },
                    end: {
                        line: 109,
                        column: 46
                    }
                },
                line: 109
            },
            "7": {
                name: "standardizeAddress",
                decl: {
                    start: {
                        line: 112,
                        column: 16
                    },
                    end: {
                        line: 112,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 112,
                        column: 66
                    },
                    end: {
                        line: 149,
                        column: 1
                    }
                },
                line: 112
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 148,
                        column: 11
                    },
                    end: {
                        line: 148,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 148,
                        column: 18
                    },
                    end: {
                        line: 148,
                        column: 46
                    }
                },
                line: 148
            },
            "9": {
                name: "createMortgageLead",
                decl: {
                    start: {
                        line: 170,
                        column: 16
                    },
                    end: {
                        line: 170,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 170,
                        column: 67
                    },
                    end: {
                        line: 227,
                        column: 1
                    }
                },
                line: 170
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 212,
                        column: 10
                    },
                    end: {
                        line: 212,
                        column: 11
                    }
                },
                loc: {
                    start: {
                        line: 212,
                        column: 30
                    },
                    end: {
                        line: 222,
                        column: 5
                    }
                },
                line: 212
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 223,
                        column: 11
                    },
                    end: {
                        line: 223,
                        column: 12
                    }
                },
                loc: {
                    start: {
                        line: 223,
                        column: 18
                    },
                    end: {
                        line: 226,
                        column: 5
                    }
                },
                line: 223
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 9,
                        column: 24
                    },
                    end: {
                        line: 9,
                        column: 84
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 9,
                            column: 55
                        },
                        end: {
                            line: 9,
                            column: 69
                        }
                    },
                    {
                        start: {
                            line: 9,
                            column: 72
                        },
                        end: {
                            line: 9,
                            column: 84
                        }
                    }
                ],
                line: 9
            },
            "1": {
                loc: {
                    start: {
                        line: 36,
                        column: 18
                    },
                    end: {
                        line: 36,
                        column: 38
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 36,
                            column: 18
                        },
                        end: {
                            line: 36,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 36,
                            column: 37
                        },
                        end: {
                            line: 36,
                            column: 38
                        }
                    }
                ],
                line: 36
            },
            "2": {
                loc: {
                    start: {
                        line: 37,
                        column: 21
                    },
                    end: {
                        line: 37,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 37,
                            column: 21
                        },
                        end: {
                            line: 37,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 37,
                            column: 43
                        },
                        end: {
                            line: 37,
                            column: 46
                        }
                    }
                ],
                line: 37
            },
            "3": {
                loc: {
                    start: {
                        line: 42,
                        column: 4
                    },
                    end: {
                        line: 42,
                        column: 31
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 42,
                            column: 4
                        },
                        end: {
                            line: 42,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 42
            },
            "4": {
                loc: {
                    start: {
                        line: 53,
                        column: 2
                    },
                    end: {
                        line: 55,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 53,
                            column: 2
                        },
                        end: {
                            line: 55,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 53
            },
            "5": {
                loc: {
                    start: {
                        line: 68,
                        column: 2
                    },
                    end: {
                        line: 68,
                        column: 53
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 68,
                            column: 51
                        },
                        end: {
                            line: 68,
                            column: 53
                        }
                    }
                ],
                line: 68
            },
            "6": {
                loc: {
                    start: {
                        line: 80,
                        column: 22
                    },
                    end: {
                        line: 80,
                        column: 56
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 80,
                            column: 22
                        },
                        end: {
                            line: 80,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 80,
                            column: 54
                        },
                        end: {
                            line: 80,
                            column: 56
                        }
                    }
                ],
                line: 80
            },
            "7": {
                loc: {
                    start: {
                        line: 213,
                        column: 6
                    },
                    end: {
                        line: 216,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 213,
                            column: 6
                        },
                        end: {
                            line: 216,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 213
            },
            "8": {
                loc: {
                    start: {
                        line: 218,
                        column: 6
                    },
                    end: {
                        line: 220,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 218,
                            column: 6
                        },
                        end: {
                            line: 220,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 218
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "ff4b1abb905f603a0b34bacb9a52427b094d7cb2"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_138knjrxo4 = function cov_138knjrxo4() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_138knjrxo4();
function _regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_instanceof/* default */.Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return _regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
        return this;
    }), _regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function _regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            _regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, _regeneratorDefine2(e, r, n, t);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}



























function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}



var DEPLOY_ENV = (cov_138knjrxo4().s[0]++, (0,globals/* getDeployEnv */.BS)());
var XSRF_COOKIE_KEY = (cov_138knjrxo4().s[1]++, DEPLOY_ENV !== "development" ? (cov_138knjrxo4().b[0][0]++, "XSRF-G-TOKEN") : (cov_138knjrxo4().b[0][1]++, "XSRF-TOKEN"));
// Hit staging Athena by default in development
//
// To hit local Athena invert the comment & uncommented `development` keys
var ATHENA_URLS = (cov_138knjrxo4().s[2]++, {
    production: "https://graphql.apps.opendoor.com/api/graphql",
    // development: 'http://localhost:4000/api/graphql',
    development: "https://graphql.simplersell.com/api/graphql",
    // development: 'http://athena-api-nginx-vpn-http.apps.internal.opendoor.com/api/graphql',
    qa: "https://graphql.simplersell.com/api/graphql",
    staging: "https://graphql.simplersell.com/api/graphql",
    test: "https://graphql.simplersell.com/api/graphql"
});
var ATHENA_URL = (cov_138knjrxo4().s[3]++, ATHENA_URLS[DEPLOY_ENV]);
/**
 * A wrapper around `fetch` with optional retries.
 * Retries up to `options.retries` times (defaults to `5` if not specified)
 * with a delay of `options.retryDelay` (defaults to `500ms` if not specified)
 */ cov_138knjrxo4().s[4]++;
var _fetchWithRetry = /*#__PURE__*/ function() {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee(url, options) {
        var retries, retryDelay, _t;
        return _regenerator().w(function(_context) {
            while(1)switch(_context.p = _context.n){
                case 0:
                    cov_138knjrxo4().f[0]++;
                    retries = (cov_138knjrxo4().s[5]++, (cov_138knjrxo4().b[1][0]++, options.retries) || (cov_138knjrxo4().b[1][1]++, 0));
                    retryDelay = (cov_138knjrxo4().s[6]++, (cov_138knjrxo4().b[2][0]++, options.retryDelay) || (cov_138knjrxo4().b[2][1]++, 500));
                    cov_138knjrxo4().s[7]++;
                    _context.p = 1;
                    cov_138knjrxo4().s[8]++;
                    _context.n = 2;
                    return fetch(url, options);
                case 2:
                    return _context.a(2, _context.v);
                case 3:
                    _context.p = 3;
                    _t = _context.v;
                    cov_138knjrxo4().s[9]++;
                    if (!(retries < 1)) {
                        _context.n = 4;
                        break;
                    }
                    cov_138knjrxo4().b[3][0]++;
                    cov_138knjrxo4().s[10]++;
                    throw _t;
                case 4:
                    cov_138knjrxo4().b[3][1]++;
                case 5:
                    cov_138knjrxo4().s[11]++;
                    _context.n = 6;
                    return new Promise(function(r) {
                        cov_138knjrxo4().f[1]++;
                        cov_138knjrxo4().s[12]++;
                        return setTimeout(r, retryDelay);
                    });
                case 6:
                    cov_138knjrxo4().s[13]++;
                    _context.n = 7;
                    return _fetchWithRetry(url, _objectSpread(_objectSpread({}, options), {}, {
                        retries: retries - 1
                    }));
                case 7:
                    return _context.a(2, _context.v);
            }
        }, _callee, null, [
            [
                1,
                3
            ]
        ]);
    }));
    return function fetchWithRetry(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var Sentry = (cov_138knjrxo4().s[14]++, observability_slim/* globalObservability.getSentryClient */.w.getSentryClient());
function handleResponse(res) {
    var _Sentry$withScope;
    cov_138knjrxo4().f[2]++;
    cov_138knjrxo4().s[15]++;
    if (res.ok) {
        cov_138knjrxo4().b[4][0]++;
        cov_138knjrxo4().s[16]++;
        return res.json();
    } else {
        cov_138knjrxo4().b[4][1]++;
    }
    cov_138knjrxo4().s[17]++;
    (_Sentry$withScope = Sentry.withScope) === null || _Sentry$withScope === void 0 || _Sentry$withScope.call(Sentry, function(scope) {
        var _Sentry$captureMessag;
        cov_138knjrxo4().f[3]++;
        cov_138knjrxo4().s[18]++;
        scope.setExtras({
            resonse: res
        });
        cov_138knjrxo4().s[19]++;
        (_Sentry$captureMessag = Sentry.captureMessage) === null || _Sentry$captureMessag === void 0 || _Sentry$captureMessag.call(Sentry, "Non-200 response received in api call");
    });
    cov_138knjrxo4().s[20]++;
    return undefined;
}
// To do: strengthen jsonParam's type
// Do not pass skip doBFFPost as it will not actually skip making the request - instead handle it conditionally
function doBFFPost(apiUrl, jsonParams) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_138knjrxo4().b[5][0]++, {});
    cov_138knjrxo4().f[4]++;
    cov_138knjrxo4().s[21]++;
    return _fetchWithRetry(apiUrl, _objectSpread(_objectSpread({
        retries: 5,
        retryDelay: 500,
        credentials: "include",
        method: "POST",
        body: JSON.stringify(jsonParams)
    }, options), {}, {
        headers: _objectSpread({
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-CSRF-Token": (cov_138knjrxo4().b[6][0]++, js_cookie.get(XSRF_COOKIE_KEY)) || (cov_138knjrxo4().b[6][1]++, "")
        }, options.headers)
    }));
}
function listUnits(addressUUID) {
    cov_138knjrxo4().f[5]++;
    cov_138knjrxo4().s[22]++;
    return doBFFPost(ATHENA_URL, {
        operationName: "ListUnits",
        query: "query ListUnits($addressUUID: String!, $limit: Float!) {\n        casa {\n          listUnits(input: { uuid: $addressUUID, limit: $limit }) {\n            addresses{\n              uuid\n              result\n            }\n          }\n        }\n      }",
        variables: {
            addressUUID: addressUUID,
            limit: 10
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(handleResponse)["catch"](function(e) {
        var _Sentry$captureExcept;
        cov_138knjrxo4().f[6]++;
        cov_138knjrxo4().s[23]++;
        return (_Sentry$captureExcept = Sentry.captureException) === null || _Sentry$captureExcept === void 0 ? void 0 : _Sentry$captureExcept.call(Sentry, e);
    });
}
function standardizeAddress(address) {
    cov_138knjrxo4().f[7]++;
    cov_138knjrxo4().s[24]++;
    return doBFFPost(ATHENA_URL, {
        operationName: "StandardizeAddress",
        query: "query StandardizeAddress($address: OdProtosCasaServices_CasaRequest_FindByFieldsInput!) {\n      casa {\n        findByFields(input: $address) {\n          address {\n            uuid\n            street\n            city\n            state\n            unitNumber\n            unitType\n            postalCode\n            latitude\n            longitude\n            result\n          }\n        }\n      }\n    }",
        variables: {
            address: {
                city: address.city,
                postalCode: address.postal_code,
                state: address.state,
                street: address.street1,
                unitNumber: address.unit
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(handleResponse)["catch"](function(e) {
        var _Sentry$captureExcept2;
        cov_138knjrxo4().f[8]++;
        cov_138knjrxo4().s[25]++;
        return (_Sentry$captureExcept2 = Sentry.captureException) === null || _Sentry$captureExcept2 === void 0 ? void 0 : _Sentry$captureExcept2.call(Sentry, e);
    });
}
function createMortgageLead(input) {
    cov_138knjrxo4().f[9]++;
    var mutation = (cov_138knjrxo4().s[26]++, "\n    mutation MortgageLead($input: OdProtosCustomerFinancingServiceServices_CustomerFinancingRequests_CreateMortgageLeadInput!) {\n      customerFinancingService {\n        createMortgageLead(input: $input) {\n          mortgageLead {\n            mortgageLeadId\n            customerUuid\n          }\n        }\n      }\n    }\n  ");
    cov_138knjrxo4().s[27]++;
    return doBFFPost(ATHENA_URL, {
        operationName: "MortgageLead",
        query: mutation,
        variables: {
            input: {
                customerUuid: input.customerUuid,
                channel: "CUSTOMER_EXPERIENCE",
                addressToken: input === null || input === void 0 ? void 0 : input.addressToken,
                propertyType: input.propertyType,
                targetMoveDate: input.targetMoveDate,
                targetPrice: input.targetPrice,
                targetDownPayment: input.targetDownPayment,
                targetLocation: input.targetLocation,
                employmentStatus: input.employmentStatus,
                householdIncomeMin: input.householdIncomeMin,
                householdIncomeMax: input.householdIncomeMax,
                firstName: input.firstName,
                lastName: input.lastName,
                phone: input.phone,
                email: input.email,
                currentAddress: input.currentAddress
            }
        }
    }, {
        headers: {
            "apollographql-client-name": "cinderblocks"
        }
    }).then(/*#__PURE__*/ function() {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(response) {
            var errorText, result;
            return _regenerator().w(function(_context2) {
                while(1)switch(_context2.n){
                    case 0:
                        cov_138knjrxo4().f[10]++;
                        cov_138knjrxo4().s[28]++;
                        if (response.ok) {
                            _context2.n = 2;
                            break;
                        }
                        cov_138knjrxo4().b[7][0]++;
                        cov_138knjrxo4().s[29]++;
                        _context2.n = 1;
                        return response.text();
                    case 1:
                        errorText = _context2.v;
                        cov_138knjrxo4().s[30]++;
                        throw new Error("GraphQL mutation failed: ".concat(errorText));
                    case 2:
                        cov_138knjrxo4().b[7][1]++;
                    case 3:
                        cov_138knjrxo4().s[31]++;
                        _context2.n = 4;
                        return response.json();
                    case 4:
                        result = _context2.v;
                        cov_138knjrxo4().s[32]++;
                        if (!result.errors) {
                            _context2.n = 5;
                            break;
                        }
                        cov_138knjrxo4().b[8][0]++;
                        cov_138knjrxo4().s[33]++;
                        throw new Error("GraphQL errors: ".concat(JSON.stringify(result.errors)));
                    case 5:
                        cov_138knjrxo4().b[8][1]++;
                    case 6:
                        cov_138knjrxo4().s[34]++;
                        return _context2.a(2, result);
                }
            }, _callee2);
        }));
        return function(_x3) {
            return _ref2.apply(this, arguments);
        };
    }())["catch"](function(e) {
        var _Sentry$captureExcept3;
        cov_138knjrxo4().f[11]++;
        cov_138knjrxo4().s[35]++;
        (_Sentry$captureExcept3 = Sentry.captureException) === null || _Sentry$captureExcept3 === void 0 || _Sentry$captureExcept3.call(Sentry, e);
        cov_138knjrxo4().s[36]++;
        throw e;
    });
} //# sourceMappingURL=api.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/addressValidation.mjs

function cov_24nvx1ule8() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/addressValidation.ts";
    var hash = "5ba9a6d5516d4aebe4f5139003b643a35e6dfbc1";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/addressValidation.ts",
        statementMap: {
            "0": {
                start: {
                    line: 3,
                    column: 30
                },
                end: {
                    line: 3,
                    column: 68
                }
            },
            "1": {
                start: {
                    line: 28,
                    column: 56
                },
                end: {
                    line: 41,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 63,
                    column: 37
                },
                end: {
                    line: 74,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 64,
                    column: 19
                },
                end: {
                    line: 64,
                    column: 47
                }
            },
            "4": {
                start: {
                    line: 65,
                    column: 20
                },
                end: {
                    line: 65,
                    column: 68
                }
            },
            "5": {
                start: {
                    line: 67,
                    column: 2
                },
                end: {
                    line: 73,
                    column: 4
                }
            },
            "6": {
                start: {
                    line: 69,
                    column: 6
                },
                end: {
                    line: 72,
                    column: 7
                }
            },
            "7": {
                start: {
                    line: 71,
                    column: 8
                },
                end: {
                    line: 71,
                    column: 51
                }
            },
            "8": {
                start: {
                    line: 76,
                    column: 31
                },
                end: {
                    line: 133,
                    column: 1
                }
            },
            "9": {
                start: {
                    line: 79,
                    column: 37
                },
                end: {
                    line: 79,
                    column: 39
                }
            },
            "10": {
                start: {
                    line: 80,
                    column: 20
                },
                end: {
                    line: 80,
                    column: 27
                }
            },
            "11": {
                start: {
                    line: 83,
                    column: 2
                },
                end: {
                    line: 112,
                    column: 3
                }
            },
            "12": {
                start: {
                    line: 84,
                    column: 39
                },
                end: {
                    line: 84,
                    column: 72
                }
            },
            "13": {
                start: {
                    line: 85,
                    column: 4
                },
                end: {
                    line: 98,
                    column: 5
                }
            },
            "14": {
                start: {
                    line: 91,
                    column: 6
                },
                end: {
                    line: 91,
                    column: 39
                }
            },
            "15": {
                start: {
                    line: 92,
                    column: 6
                },
                end: {
                    line: 97,
                    column: 8
                }
            },
            "16": {
                start: {
                    line: 99,
                    column: 26
                },
                end: {
                    line: 99,
                    column: 85
                }
            },
            "17": {
                start: {
                    line: 100,
                    column: 4
                },
                end: {
                    line: 111,
                    column: 6
                }
            },
            "18": {
                start: {
                    line: 115,
                    column: 2
                },
                end: {
                    line: 119,
                    column: 3
                }
            },
            "19": {
                start: {
                    line: 116,
                    column: 4
                },
                end: {
                    line: 118,
                    column: 5
                }
            },
            "20": {
                start: {
                    line: 117,
                    column: 6
                },
                end: {
                    line: 117,
                    column: 51
                }
            },
            "21": {
                start: {
                    line: 121,
                    column: 26
                },
                end: {
                    line: 121,
                    column: 73
                }
            },
            "22": {
                start: {
                    line: 124,
                    column: 27
                },
                end: {
                    line: 124,
                    column: 98
                }
            },
            "23": {
                start: {
                    line: 124,
                    column: 66
                },
                end: {
                    line: 124,
                    column: 97
                }
            },
            "24": {
                start: {
                    line: 125,
                    column: 29
                },
                end: {
                    line: 125,
                    column: 84
                }
            },
            "25": {
                start: {
                    line: 127,
                    column: 2
                },
                end: {
                    line: 132,
                    column: 4
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 63,
                        column: 37
                    },
                    end: {
                        line: 63,
                        column: 38
                    }
                },
                loc: {
                    start: {
                        line: 63,
                        column: 86
                    },
                    end: {
                        line: 74,
                        column: 1
                    }
                },
                line: 63
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 68,
                        column: 4
                    },
                    end: {
                        line: 68,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 69,
                        column: 6
                    },
                    end: {
                        line: 72,
                        column: 7
                    }
                },
                line: 69
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 70,
                        column: 28
                    },
                    end: {
                        line: 70,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 71,
                        column: 8
                    },
                    end: {
                        line: 71,
                        column: 51
                    }
                },
                line: 71
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 76,
                        column: 31
                    },
                    end: {
                        line: 76,
                        column: 32
                    }
                },
                loc: {
                    start: {
                        line: 78,
                        column: 39
                    },
                    end: {
                        line: 133,
                        column: 1
                    }
                },
                line: 78
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 124,
                        column: 55
                    },
                    end: {
                        line: 124,
                        column: 56
                    }
                },
                loc: {
                    start: {
                        line: 124,
                        column: 66
                    },
                    end: {
                        line: 124,
                        column: 97
                    }
                },
                line: 124
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 65,
                        column: 20
                    },
                    end: {
                        line: 65,
                        column: 68
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 65,
                            column: 20
                        },
                        end: {
                            line: 65,
                            column: 62
                        }
                    },
                    {
                        start: {
                            line: 65,
                            column: 66
                        },
                        end: {
                            line: 65,
                            column: 68
                        }
                    }
                ],
                line: 65
            },
            "1": {
                loc: {
                    start: {
                        line: 69,
                        column: 6
                    },
                    end: {
                        line: 72,
                        column: 7
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 69,
                            column: 6
                        },
                        end: {
                            line: 69,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 70,
                            column: 6
                        },
                        end: {
                            line: 72,
                            column: 7
                        }
                    }
                ],
                line: 69
            },
            "2": {
                loc: {
                    start: {
                        line: 83,
                        column: 2
                    },
                    end: {
                        line: 112,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 83,
                            column: 2
                        },
                        end: {
                            line: 112,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 83
            },
            "3": {
                loc: {
                    start: {
                        line: 85,
                        column: 4
                    },
                    end: {
                        line: 98,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 85,
                            column: 4
                        },
                        end: {
                            line: 98,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 85
            },
            "4": {
                loc: {
                    start: {
                        line: 86,
                        column: 6
                    },
                    end: {
                        line: 89,
                        column: 97
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 86,
                            column: 6
                        },
                        end: {
                            line: 86,
                            column: 33
                        }
                    },
                    {
                        start: {
                            line: 87,
                            column: 6
                        },
                        end: {
                            line: 87,
                            column: 38
                        }
                    },
                    {
                        start: {
                            line: 88,
                            column: 6
                        },
                        end: {
                            line: 88,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 89,
                            column: 6
                        },
                        end: {
                            line: 89,
                            column: 97
                        }
                    }
                ],
                line: 86
            },
            "5": {
                loc: {
                    start: {
                        line: 115,
                        column: 2
                    },
                    end: {
                        line: 119,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 115,
                            column: 2
                        },
                        end: {
                            line: 119,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 115
            },
            "6": {
                loc: {
                    start: {
                        line: 115,
                        column: 6
                    },
                    end: {
                        line: 115,
                        column: 95
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 115,
                            column: 6
                        },
                        end: {
                            line: 115,
                            column: 67
                        }
                    },
                    {
                        start: {
                            line: 115,
                            column: 71
                        },
                        end: {
                            line: 115,
                            column: 95
                        }
                    }
                ],
                line: 115
            },
            "7": {
                loc: {
                    start: {
                        line: 116,
                        column: 4
                    },
                    end: {
                        line: 118,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 116,
                            column: 4
                        },
                        end: {
                            line: 118,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 116
            },
            "8": {
                loc: {
                    start: {
                        line: 116,
                        column: 8
                    },
                    end: {
                        line: 116,
                        column: 78
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 116,
                            column: 8
                        },
                        end: {
                            line: 116,
                            column: 22
                        }
                    },
                    {
                        start: {
                            line: 116,
                            column: 27
                        },
                        end: {
                            line: 116,
                            column: 77
                        }
                    }
                ],
                line: 116
            },
            "9": {
                loc: {
                    start: {
                        line: 121,
                        column: 31
                    },
                    end: {
                        line: 121,
                        column: 56
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 121,
                            column: 31
                        },
                        end: {
                            line: 121,
                            column: 50
                        }
                    },
                    {
                        start: {
                            line: 121,
                            column: 54
                        },
                        end: {
                            line: 121,
                            column: 56
                        }
                    }
                ],
                line: 121
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0,
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "5ba9a6d5516d4aebe4f5139003b643a35e6dfbc1"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_24nvx1ule8 = function cov_24nvx1ule8() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_24nvx1ule8();
function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function addressValidation_regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_instanceof/* default */.Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return addressValidation_regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, addressValidation_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (addressValidation_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, addressValidation_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), addressValidation_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", addressValidation_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), addressValidation_regeneratorDefine2(u), addressValidation_regeneratorDefine2(u, o, "Generator"), addressValidation_regeneratorDefine2(u, n, function() {
        return this;
    }), addressValidation_regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (addressValidation_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function addressValidation_regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    addressValidation_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            addressValidation_regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, addressValidation_regeneratorDefine2(e, r, n, t);
}























function addressValidation_asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function addressValidation_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                addressValidation_asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                addressValidation_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

var UNIVERSAL_NIL_ADDRESS = (cov_24nvx1ule8().s[0]++, "6aae647b-d603-5533-8464-c42c658b101a");

// TODO: Duplicated here like other places in cinderblocks. Until we figure out
// how to share GraphQL codegen.
var ADDRESS_INVALID_RESULT = (cov_24nvx1ule8().s[1]++, [
    "ADDRESS_NIL",
    "ADDRESS_UNKNOWN",
    "ADDRESS_MISSING_PREMISE",
    "ADDRESS_INVALID_PREMISE",
    "ADDRESS_NOT_SUPPORTED",
    "ADDRESS_NOT_REAL",
    "ADDRESS_INVALID",
    "ADDRESS_INVALID_STREET",
    "ADDRESS_INVALID_SUB_PREMISE",
    "ADDRESS_MISSING_BOX_NUMBER",
    "ADDRESS_INVALID_BOX_NUMBER",
    "ADDRESS_EXTRANEOUS_INPUT"
]);
cov_24nvx1ule8().s[2]++;
var doesAddressHaveMultipleUnits = /*#__PURE__*/ function() {
    var _ref = addressValidation_asyncToGenerator(/*#__PURE__*/ addressValidation_regenerator().m(function _callee(addressUuid) {
        var _response$data;
        var response, addresses;
        return addressValidation_regenerator().w(function(_context) {
            while(1)switch(_context.n){
                case 0:
                    cov_24nvx1ule8().f[0]++;
                    cov_24nvx1ule8().s[3]++;
                    _context.n = 1;
                    return listUnits(addressUuid);
                case 1:
                    response = _context.v;
                    addresses = (cov_24nvx1ule8().s[4]++, (cov_24nvx1ule8().b[0][0]++, response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 || (_response$data = _response$data.casa) === null || _response$data === void 0 || (_response$data = _response$data.listUnits) === null || _response$data === void 0 ? void 0 : _response$data.addresses) || (cov_24nvx1ule8().b[0][1]++, []));
                    cov_24nvx1ule8().s[5]++;
                    return _context.a(2, addresses.some(function(address) {
                        var _address$result;
                        cov_24nvx1ule8().f[1]++;
                        cov_24nvx1ule8().s[6]++;
                        return (cov_24nvx1ule8().b[1][0]++, address.uuid !== addressUuid) && (cov_24nvx1ule8().b[1][1]++, !((_address$result = address.result) !== null && _address$result !== void 0 && _address$result.some(function(casaResult) {
                            cov_24nvx1ule8().f[2]++;
                            cov_24nvx1ule8().s[7]++;
                            return ADDRESS_INVALID_RESULT.includes(casaResult);
                        })));
                    }));
            }
        }, _callee);
    }));
    return function doesAddressHaveMultipleUnits(_x) {
        return _ref.apply(this, arguments);
    };
}();
cov_24nvx1ule8().s[8]++;
var addressValidation_validateAddress = /*#__PURE__*/ function() {
    var _ref2 = addressValidation_asyncToGenerator(/*#__PURE__*/ addressValidation_regenerator().m(function _callee2(address) {
        var _casaAddress, _casaAddress2, _casaAddress3;
        var moreResult, casaAddress, _standardizeAddressRe, _standardizeAddressRe2, standardizeAddressResponse, addressResult, combinedResults, needsManualEntry, needsUnitSelection, _t;
        return addressValidation_regenerator().w(function(_context2) {
            while(1)switch(_context2.n){
                case 0:
                    cov_24nvx1ule8().f[3]++;
                    moreResult = (cov_24nvx1ule8().s[9]++, []);
                    casaAddress = (cov_24nvx1ule8().s[10]++, address); // Standardize Google addresses to Casa format
                    cov_24nvx1ule8().s[11]++;
                    if (!(address.source === "google")) {
                        _context2.n = 4;
                        break;
                    }
                    cov_24nvx1ule8().b[2][0]++;
                    cov_24nvx1ule8().s[12]++;
                    _context2.n = 1;
                    return standardizeAddress(address);
                case 1:
                    standardizeAddressResponse = _context2.v;
                    cov_24nvx1ule8().s[13]++;
                    if (!((cov_24nvx1ule8().b[4][0]++, !standardizeAddressResponse) || (cov_24nvx1ule8().b[4][1]++, !standardizeAddressResponse.data) || (cov_24nvx1ule8().b[4][2]++, standardizeAddressResponse.errors) || (cov_24nvx1ule8().b[4][3]++, ((_standardizeAddressRe = standardizeAddressResponse.data) === null || _standardizeAddressRe === void 0 || (_standardizeAddressRe = _standardizeAddressRe.casa.findByFields) === null || _standardizeAddressRe === void 0 || (_standardizeAddressRe = _standardizeAddressRe.address) === null || _standardizeAddressRe === void 0 ? void 0 : _standardizeAddressRe.uuid) === UNIVERSAL_NIL_ADDRESS))) {
                        _context2.n = 2;
                        break;
                    }
                    cov_24nvx1ule8().b[3][0]++;
                    cov_24nvx1ule8().s[14]++;
                    moreResult = [
                        "ADDRESS_UNKNOWN"
                    ];
                    cov_24nvx1ule8().s[15]++;
                    return _context2.a(2, {
                        address: address,
                        results: moreResult,
                        needsManualEntry: true,
                        needsUnitSelection: false
                    });
                case 2:
                    cov_24nvx1ule8().b[3][1]++;
                case 3:
                    addressResult = (cov_24nvx1ule8().s[16]++, (_standardizeAddressRe2 = standardizeAddressResponse.data) === null || _standardizeAddressRe2 === void 0 || (_standardizeAddressRe2 = _standardizeAddressRe2.casa.findByFields) === null || _standardizeAddressRe2 === void 0 ? void 0 : _standardizeAddressRe2.address);
                    cov_24nvx1ule8().s[17]++;
                    casaAddress = {
                        id: addressResult.uuid,
                        street1: addressResult.street,
                        city: addressResult.city,
                        state: addressResult.state,
                        postal_code: addressResult.postalCode,
                        unit: addressResult.unitNumber,
                        result: addressResult.result,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        source: "casa"
                    };
                    _context2.n = 5;
                    break;
                case 4:
                    cov_24nvx1ule8().b[2][1]++;
                case 5:
                    cov_24nvx1ule8().s[18]++;
                    if (!((cov_24nvx1ule8().b[6][0]++, !((_casaAddress = casaAddress) !== null && _casaAddress !== void 0 && (_casaAddress = _casaAddress.result) !== null && _casaAddress !== void 0 && _casaAddress.includes("ADDRESS_MISSING_SUB_PREMISE"))) && (cov_24nvx1ule8().b[6][1]++, ((_casaAddress2 = casaAddress) === null || _casaAddress2 === void 0 ? void 0 : _casaAddress2.unit) === ""))) {
                        _context2.n = 10;
                        break;
                    }
                    cov_24nvx1ule8().b[5][0]++;
                    cov_24nvx1ule8().s[19]++;
                    _t = (cov_24nvx1ule8().b[8][0]++, casaAddress.id);
                    if (!_t) {
                        _context2.n = 7;
                        break;
                    }
                    cov_24nvx1ule8().b[8][1]++;
                    _context2.n = 6;
                    return doesAddressHaveMultipleUnits(casaAddress.id);
                case 6:
                    _t = _context2.v;
                case 7:
                    if (!_t) {
                        _context2.n = 8;
                        break;
                    }
                    cov_24nvx1ule8().b[7][0]++;
                    cov_24nvx1ule8().s[20]++;
                    moreResult = [
                        "ADDRESS_MISSING_SUB_PREMISE"
                    ];
                    _context2.n = 9;
                    break;
                case 8:
                    cov_24nvx1ule8().b[7][1]++;
                case 9:
                    _context2.n = 11;
                    break;
                case 10:
                    cov_24nvx1ule8().b[5][1]++;
                case 11:
                    combinedResults = (cov_24nvx1ule8().s[21]++, [].concat(_toConsumableArray((cov_24nvx1ule8().b[9][0]++, (_casaAddress3 = casaAddress) === null || _casaAddress3 === void 0 ? void 0 : _casaAddress3.result) || (cov_24nvx1ule8().b[9][1]++, [])), _toConsumableArray(moreResult))); // Check if address has invalid results
                    needsManualEntry = (cov_24nvx1ule8().s[22]++, ADDRESS_INVALID_RESULT.some(function(error) {
                        cov_24nvx1ule8().f[4]++;
                        cov_24nvx1ule8().s[23]++;
                        return combinedResults.includes(error);
                    }));
                    needsUnitSelection = (cov_24nvx1ule8().s[24]++, combinedResults.includes("ADDRESS_MISSING_SUB_PREMISE"));
                    cov_24nvx1ule8().s[25]++;
                    return _context2.a(2, {
                        address: casaAddress,
                        results: combinedResults,
                        needsManualEntry: needsManualEntry,
                        needsUnitSelection: needsUnitSelection
                    });
            }
        }, _callee2);
    }));
    return function validateAddress(_x2) {
        return _ref2.apply(this, arguments);
    };
}(); //# sourceMappingURL=addressValidation.mjs.map

// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/helpers/googleMaps.mjs
var googleMaps = __webpack_require__(99835);
// EXTERNAL MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AutocompleteInput/index.mjs + 1 modules
var AutocompleteInput = __webpack_require__(59801);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AddressInput/AddressInput.mjs

function cov_utly8d7bp() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/core/AddressInput/AddressInput.tsx";
    var hash = "a6a2328d7a69b41fc72a7075499760680807594a";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/core/AddressInput/AddressInput.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 18,
                    column: 32
                },
                end: {
                    line: 18,
                    column: 35
                }
            },
            "1": {
                start: {
                    line: 102,
                    column: 50
                },
                end: {
                    line: 360,
                    column: 1
                }
            },
            "2": {
                start: {
                    line: 131,
                    column: 40
                },
                end: {
                    line: 131,
                    column: 78
                }
            },
            "3": {
                start: {
                    line: 132,
                    column: 46
                },
                end: {
                    line: 132,
                    column: 91
                }
            },
            "4": {
                start: {
                    line: 133,
                    column: 54
                },
                end: {
                    line: 133,
                    column: 82
                }
            },
            "5": {
                start: {
                    line: 134,
                    column: 36
                },
                end: {
                    line: 134,
                    column: 51
                }
            },
            "6": {
                start: {
                    line: 135,
                    column: 25
                },
                end: {
                    line: 135,
                    column: 73
                }
            },
            "7": {
                start: {
                    line: 135,
                    column: 40
                },
                end: {
                    line: 135,
                    column: 72
                }
            },
            "8": {
                start: {
                    line: 136,
                    column: 19
                },
                end: {
                    line: 136,
                    column: 49
                }
            },
            "9": {
                start: {
                    line: 137,
                    column: 22
                },
                end: {
                    line: 137,
                    column: 35
                }
            },
            "10": {
                start: {
                    line: 140,
                    column: 23
                },
                end: {
                    line: 140,
                    column: 42
                }
            },
            "11": {
                start: {
                    line: 141,
                    column: 21
                },
                end: {
                    line: 141,
                    column: 62
                }
            },
            "12": {
                start: {
                    line: 143,
                    column: 27
                },
                end: {
                    line: 148,
                    column: 3
                }
            },
            "13": {
                start: {
                    line: 144,
                    column: 4
                },
                end: {
                    line: 146,
                    column: 5
                }
            },
            "14": {
                start: {
                    line: 145,
                    column: 6
                },
                end: {
                    line: 145,
                    column: 38
                }
            },
            "15": {
                start: {
                    line: 147,
                    column: 4
                },
                end: {
                    line: 147,
                    column: 25
                }
            },
            "16": {
                start: {
                    line: 150,
                    column: 2
                },
                end: {
                    line: 152,
                    column: 41
                }
            },
            "17": {
                start: {
                    line: 151,
                    column: 4
                },
                end: {
                    line: 151,
                    column: 39
                }
            },
            "18": {
                start: {
                    line: 156,
                    column: 2
                },
                end: {
                    line: 160,
                    column: 53
                }
            },
            "19": {
                start: {
                    line: 157,
                    column: 4
                },
                end: {
                    line: 159,
                    column: 5
                }
            },
            "20": {
                start: {
                    line: 158,
                    column: 6
                },
                end: {
                    line: 158,
                    column: 39
                }
            },
            "21": {
                start: {
                    line: 162,
                    column: 27
                },
                end: {
                    line: 165,
                    column: 3
                }
            },
            "22": {
                start: {
                    line: 163,
                    column: 4
                },
                end: {
                    line: 163,
                    column: 28
                }
            },
            "23": {
                start: {
                    line: 164,
                    column: 4
                },
                end: {
                    line: 164,
                    column: 23
                }
            },
            "24": {
                start: {
                    line: 167,
                    column: 35
                },
                end: {
                    line: 209,
                    column: 3
                }
            },
            "25": {
                start: {
                    line: 169,
                    column: 6
                },
                end: {
                    line: 207,
                    column: 33
                }
            },
            "26": {
                start: {
                    line: 170,
                    column: 8
                },
                end: {
                    line: 173,
                    column: 9
                }
            },
            "27": {
                start: {
                    line: 171,
                    column: 10
                },
                end: {
                    line: 171,
                    column: 29
                }
            },
            "28": {
                start: {
                    line: 172,
                    column: 10
                },
                end: {
                    line: 172,
                    column: 17
                }
            },
            "29": {
                start: {
                    line: 175,
                    column: 8
                },
                end: {
                    line: 206,
                    column: 9
                }
            },
            "30": {
                start: {
                    line: 176,
                    column: 27
                },
                end: {
                    line: 176,
                    column: 81
                }
            },
            "31": {
                start: {
                    line: 177,
                    column: 23
                },
                end: {
                    line: 177,
                    column: 44
                }
            },
            "32": {
                start: {
                    line: 180,
                    column: 10
                },
                end: {
                    line: 184,
                    column: 13
                }
            },
            "33": {
                start: {
                    line: 181,
                    column: 12
                },
                end: {
                    line: 181,
                    column: 73
                }
            },
            "34": {
                start: {
                    line: 182,
                    column: 12
                },
                end: {
                    line: 182,
                    column: 85
                }
            },
            "35": {
                start: {
                    line: 183,
                    column: 12
                },
                end: {
                    line: 183,
                    column: 50
                }
            },
            "36": {
                start: {
                    line: 187,
                    column: 27
                },
                end: {
                    line: 200,
                    column: 12
                }
            },
            "37": {
                start: {
                    line: 188,
                    column: 12
                },
                end: {
                    line: 188,
                    column: 40
                }
            },
            "38": {
                start: {
                    line: 189,
                    column: 12
                },
                end: {
                    line: 198,
                    column: 13
                }
            },
            "39": {
                start: {
                    line: 190,
                    column: 28
                },
                end: {
                    line: 190,
                    column: 46
                }
            },
            "40": {
                start: {
                    line: 191,
                    column: 35
                },
                end: {
                    line: 193,
                    column: 15
                }
            },
            "41": {
                start: {
                    line: 192,
                    column: 16
                },
                end: {
                    line: 192,
                    column: 44
                }
            },
            "42": {
                start: {
                    line: 194,
                    column: 14
                },
                end: {
                    line: 197,
                    column: 16
                }
            },
            "43": {
                start: {
                    line: 199,
                    column: 12
                },
                end: {
                    line: 199,
                    column: 24
                }
            },
            "44": {
                start: {
                    line: 202,
                    column: 10
                },
                end: {
                    line: 202,
                    column: 35
                }
            },
            "45": {
                start: {
                    line: 204,
                    column: 10
                },
                end: {
                    line: 204,
                    column: 29
                }
            },
            "46": {
                start: {
                    line: 205,
                    column: 10
                },
                end: {
                    line: 205,
                    column: 36
                }
            },
            "47": {
                start: {
                    line: 212,
                    column: 2
                },
                end: {
                    line: 229,
                    column: 67
                }
            },
            "48": {
                start: {
                    line: 213,
                    column: 4
                },
                end: {
                    line: 213,
                    column: 38
                }
            },
            "49": {
                start: {
                    line: 213,
                    column: 31
                },
                end: {
                    line: 213,
                    column: 38
                }
            },
            "50": {
                start: {
                    line: 216,
                    column: 4
                },
                end: {
                    line: 219,
                    column: 5
                }
            },
            "51": {
                start: {
                    line: 217,
                    column: 6
                },
                end: {
                    line: 217,
                    column: 33
                }
            },
            "52": {
                start: {
                    line: 218,
                    column: 6
                },
                end: {
                    line: 218,
                    column: 13
                }
            },
            "53": {
                start: {
                    line: 222,
                    column: 4
                },
                end: {
                    line: 226,
                    column: 5
                }
            },
            "54": {
                start: {
                    line: 223,
                    column: 6
                },
                end: {
                    line: 223,
                    column: 25
                }
            },
            "55": {
                start: {
                    line: 225,
                    column: 6
                },
                end: {
                    line: 225,
                    column: 43
                }
            },
            "56": {
                start: {
                    line: 231,
                    column: 28
                },
                end: {
                    line: 238,
                    column: 3
                }
            },
            "57": {
                start: {
                    line: 232,
                    column: 21
                },
                end: {
                    line: 232,
                    column: 35
                }
            },
            "58": {
                start: {
                    line: 233,
                    column: 4
                },
                end: {
                    line: 233,
                    column: 31
                }
            },
            "59": {
                start: {
                    line: 234,
                    column: 4
                },
                end: {
                    line: 234,
                    column: 39
                }
            },
            "60": {
                start: {
                    line: 235,
                    column: 4
                },
                end: {
                    line: 237,
                    column: 5
                }
            },
            "61": {
                start: {
                    line: 236,
                    column: 6
                },
                end: {
                    line: 236,
                    column: 25
                }
            },
            "62": {
                start: {
                    line: 240,
                    column: 33
                },
                end: {
                    line: 282,
                    column: 3
                }
            },
            "63": {
                start: {
                    line: 242,
                    column: 4
                },
                end: {
                    line: 242,
                    column: 29
                }
            },
            "64": {
                start: {
                    line: 244,
                    column: 4
                },
                end: {
                    line: 244,
                    column: 34
                }
            },
            "65": {
                start: {
                    line: 245,
                    column: 4
                },
                end: {
                    line: 245,
                    column: 45
                }
            },
            "66": {
                start: {
                    line: 246,
                    column: 4
                },
                end: {
                    line: 246,
                    column: 23
                }
            },
            "67": {
                start: {
                    line: 247,
                    column: 4
                },
                end: {
                    line: 247,
                    column: 23
                }
            },
            "68": {
                start: {
                    line: 250,
                    column: 6
                },
                end: {
                    line: 260,
                    column: 12
                }
            },
            "69": {
                start: {
                    line: 262,
                    column: 4
                },
                end: {
                    line: 281,
                    column: 5
                }
            },
            "70": {
                start: {
                    line: 263,
                    column: 23
                },
                end: {
                    line: 263,
                    column: 39
                }
            },
            "71": {
                start: {
                    line: 264,
                    column: 39
                },
                end: {
                    line: 264,
                    column: 60
                }
            },
            "72": {
                start: {
                    line: 267,
                    column: 6
                },
                end: {
                    line: 274,
                    column: 7
                }
            },
            "73": {
                start: {
                    line: 268,
                    column: 8
                },
                end: {
                    line: 273,
                    column: 9
                }
            },
            "74": {
                start: {
                    line: 269,
                    column: 35
                },
                end: {
                    line: 269,
                    column: 71
                }
            },
            "75": {
                start: {
                    line: 270,
                    column: 10
                },
                end: {
                    line: 270,
                    column: 47
                }
            },
            "76": {
                start: {
                    line: 272,
                    column: 10
                },
                end: {
                    line: 272,
                    column: 46
                }
            },
            "77": {
                start: {
                    line: 276,
                    column: 6
                },
                end: {
                    line: 276,
                    column: 31
                }
            },
            "78": {
                start: {
                    line: 278,
                    column: 6
                },
                end: {
                    line: 278,
                    column: 32
                }
            },
            "79": {
                start: {
                    line: 280,
                    column: 6
                },
                end: {
                    line: 280,
                    column: 26
                }
            },
            "80": {
                start: {
                    line: 284,
                    column: 21
                },
                end: {
                    line: 308,
                    column: 3
                }
            },
            "81": {
                start: {
                    line: 286,
                    column: 26
                },
                end: {
                    line: 291,
                    column: 14
                }
            },
            "82": {
                start: {
                    line: 292,
                    column: 23
                },
                end: {
                    line: 292,
                    column: 65
                }
            },
            "83": {
                start: {
                    line: 294,
                    column: 4
                },
                end: {
                    line: 307,
                    column: 6
                }
            },
            "84": {
                start: {
                    line: 311,
                    column: 4
                },
                end: {
                    line: 318,
                    column: 6
                }
            },
            "85": {
                start: {
                    line: 320,
                    column: 35
                },
                end: {
                    line: 320,
                    column: 46
                }
            },
            "86": {
                start: {
                    line: 321,
                    column: 2
                },
                end: {
                    line: 331,
                    column: 3
                }
            },
            "87": {
                start: {
                    line: 322,
                    column: 20
                },
                end: {
                    line: 328,
                    column: 5
                }
            },
            "88": {
                start: {
                    line: 323,
                    column: 6
                },
                end: {
                    line: 327,
                    column: 7
                }
            },
            "89": {
                start: {
                    line: 324,
                    column: 8
                },
                end: {
                    line: 324,
                    column: 47
                }
            },
            "90": {
                start: {
                    line: 325,
                    column: 13
                },
                end: {
                    line: 327,
                    column: 7
                }
            },
            "91": {
                start: {
                    line: 326,
                    column: 8
                },
                end: {
                    line: 326,
                    column: 47
                }
            },
            "92": {
                start: {
                    line: 329,
                    column: 27
                },
                end: {
                    line: 329,
                    column: 59
                }
            },
            "93": {
                start: {
                    line: 330,
                    column: 4
                },
                end: {
                    line: 330,
                    column: 31
                }
            },
            "94": {
                start: {
                    line: 333,
                    column: 2
                },
                end: {
                    line: 359,
                    column: 4
                }
            },
            "95": {
                start: {
                    line: 348,
                    column: 22
                },
                end: {
                    line: 348,
                    column: 40
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 102,
                        column: 50
                    },
                    end: {
                        line: 102,
                        column: 51
                    }
                },
                loc: {
                    start: {
                        line: 130,
                        column: 6
                    },
                    end: {
                        line: 360,
                        column: 1
                    }
                },
                line: 130
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 135,
                        column: 34
                    },
                    end: {
                        line: 135,
                        column: 35
                    }
                },
                loc: {
                    start: {
                        line: 135,
                        column: 40
                    },
                    end: {
                        line: 135,
                        column: 72
                    }
                },
                line: 135
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 143,
                        column: 27
                    },
                    end: {
                        line: 143,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 143,
                        column: 49
                    },
                    end: {
                        line: 148,
                        column: 3
                    }
                },
                line: 143
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 150,
                        column: 12
                    },
                    end: {
                        line: 150,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 150,
                        column: 18
                    },
                    end: {
                        line: 152,
                        column: 3
                    }
                },
                line: 150
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 156,
                        column: 12
                    },
                    end: {
                        line: 156,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 156,
                        column: 18
                    },
                    end: {
                        line: 160,
                        column: 3
                    }
                },
                line: 156
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 162,
                        column: 27
                    },
                    end: {
                        line: 162,
                        column: 28
                    }
                },
                loc: {
                    start: {
                        line: 162,
                        column: 33
                    },
                    end: {
                        line: 165,
                        column: 3
                    }
                },
                line: 162
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 168,
                        column: 4
                    },
                    end: {
                        line: 168,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 169,
                        column: 6
                    },
                    end: {
                        line: 207,
                        column: 33
                    }
                },
                line: 169
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 169,
                        column: 15
                    },
                    end: {
                        line: 169,
                        column: 16
                    }
                },
                loc: {
                    start: {
                        line: 169,
                        column: 40
                    },
                    end: {
                        line: 207,
                        column: 7
                    }
                },
                line: 169
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 180,
                        column: 35
                    },
                    end: {
                        line: 180,
                        column: 36
                    }
                },
                loc: {
                    start: {
                        line: 180,
                        column: 71
                    },
                    end: {
                        line: 184,
                        column: 11
                    }
                },
                line: 180
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 187,
                        column: 51
                    },
                    end: {
                        line: 187,
                        column: 52
                    }
                },
                loc: {
                    start: {
                        line: 187,
                        column: 87
                    },
                    end: {
                        line: 200,
                        column: 11
                    }
                },
                line: 187
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 191,
                        column: 63
                    },
                    end: {
                        line: 191,
                        column: 64
                    }
                },
                loc: {
                    start: {
                        line: 192,
                        column: 16
                    },
                    end: {
                        line: 192,
                        column: 44
                    }
                },
                line: 192
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 212,
                        column: 12
                    },
                    end: {
                        line: 212,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 212,
                        column: 18
                    },
                    end: {
                        line: 229,
                        column: 3
                    }
                },
                line: 212
            },
            "12": {
                name: "(anonymous_12)",
                decl: {
                    start: {
                        line: 231,
                        column: 28
                    },
                    end: {
                        line: 231,
                        column: 29
                    }
                },
                loc: {
                    start: {
                        line: 231,
                        column: 72
                    },
                    end: {
                        line: 238,
                        column: 3
                    }
                },
                line: 231
            },
            "13": {
                name: "(anonymous_13)",
                decl: {
                    start: {
                        line: 240,
                        column: 33
                    },
                    end: {
                        line: 240,
                        column: 34
                    }
                },
                loc: {
                    start: {
                        line: 240,
                        column: 79
                    },
                    end: {
                        line: 282,
                        column: 3
                    }
                },
                line: 240
            },
            "14": {
                name: "(anonymous_14)",
                decl: {
                    start: {
                        line: 284,
                        column: 21
                    },
                    end: {
                        line: 284,
                        column: 22
                    }
                },
                loc: {
                    start: {
                        line: 284,
                        column: 61
                    },
                    end: {
                        line: 308,
                        column: 3
                    }
                },
                line: 284
            },
            "15": {
                name: "(anonymous_15)",
                decl: {
                    start: {
                        line: 322,
                        column: 20
                    },
                    end: {
                        line: 322,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 322,
                        column: 26
                    },
                    end: {
                        line: 328,
                        column: 5
                    }
                },
                line: 322
            },
            "16": {
                name: "(anonymous_16)",
                decl: {
                    start: {
                        line: 348,
                        column: 16
                    },
                    end: {
                        line: 348,
                        column: 17
                    }
                },
                loc: {
                    start: {
                        line: 348,
                        column: 22
                    },
                    end: {
                        line: 348,
                        column: 40
                    }
                },
                line: 348
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 111,
                        column: 2
                    },
                    end: {
                        line: 111,
                        column: 30
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 111,
                            column: 25
                        },
                        end: {
                            line: 111,
                            column: 30
                        }
                    }
                ],
                line: 111
            },
            "1": {
                loc: {
                    start: {
                        line: 114,
                        column: 2
                    },
                    end: {
                        line: 114,
                        column: 25
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 114,
                            column: 20
                        },
                        end: {
                            line: 114,
                            column: 25
                        }
                    }
                ],
                line: 114
            },
            "2": {
                loc: {
                    start: {
                        line: 133,
                        column: 63
                    },
                    end: {
                        line: 133,
                        column: 81
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 133,
                            column: 63
                        },
                        end: {
                            line: 133,
                            column: 75
                        }
                    },
                    {
                        start: {
                            line: 133,
                            column: 79
                        },
                        end: {
                            line: 133,
                            column: 81
                        }
                    }
                ],
                line: 133
            },
            "3": {
                loc: {
                    start: {
                        line: 141,
                        column: 21
                    },
                    end: {
                        line: 141,
                        column: 62
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 141,
                            column: 36
                        },
                        end: {
                            line: 141,
                            column: 41
                        }
                    },
                    {
                        start: {
                            line: 141,
                            column: 44
                        },
                        end: {
                            line: 141,
                            column: 62
                        }
                    }
                ],
                line: 141
            },
            "4": {
                loc: {
                    start: {
                        line: 144,
                        column: 4
                    },
                    end: {
                        line: 146,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 144,
                            column: 4
                        },
                        end: {
                            line: 146,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 144
            },
            "5": {
                loc: {
                    start: {
                        line: 157,
                        column: 4
                    },
                    end: {
                        line: 159,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 157,
                            column: 4
                        },
                        end: {
                            line: 159,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 157
            },
            "6": {
                loc: {
                    start: {
                        line: 170,
                        column: 8
                    },
                    end: {
                        line: 173,
                        column: 9
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 170,
                            column: 8
                        },
                        end: {
                            line: 173,
                            column: 9
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 170
            },
            "7": {
                loc: {
                    start: {
                        line: 182,
                        column: 24
                    },
                    end: {
                        line: 182,
                        column: 84
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 182,
                            column: 24
                        },
                        end: {
                            line: 182,
                            column: 39
                        }
                    },
                    {
                        start: {
                            line: 182,
                            column: 43
                        },
                        end: {
                            line: 182,
                            column: 62
                        }
                    },
                    {
                        start: {
                            line: 182,
                            column: 66
                        },
                        end: {
                            line: 182,
                            column: 84
                        }
                    }
                ],
                line: 182
            },
            "8": {
                loc: {
                    start: {
                        line: 189,
                        column: 12
                    },
                    end: {
                        line: 198,
                        column: 13
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 189,
                            column: 12
                        },
                        end: {
                            line: 198,
                            column: 13
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 189
            },
            "9": {
                loc: {
                    start: {
                        line: 190,
                        column: 28
                    },
                    end: {
                        line: 190,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 190,
                            column: 28
                        },
                        end: {
                            line: 190,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 190,
                            column: 44
                        },
                        end: {
                            line: 190,
                            column: 46
                        }
                    }
                ],
                line: 190
            },
            "10": {
                loc: {
                    start: {
                        line: 191,
                        column: 36
                    },
                    end: {
                        line: 191,
                        column: 54
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 191,
                            column: 36
                        },
                        end: {
                            line: 191,
                            column: 48
                        }
                    },
                    {
                        start: {
                            line: 191,
                            column: 52
                        },
                        end: {
                            line: 191,
                            column: 54
                        }
                    }
                ],
                line: 191
            },
            "11": {
                loc: {
                    start: {
                        line: 195,
                        column: 16
                    },
                    end: {
                        line: 196,
                        column: 87
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 195,
                            column: 17
                        },
                        end: {
                            line: 195,
                            column: 34
                        }
                    },
                    {
                        start: {
                            line: 195,
                            column: 38
                        },
                        end: {
                            line: 195,
                            column: 61
                        }
                    },
                    {
                        start: {
                            line: 196,
                            column: 17
                        },
                        end: {
                            line: 196,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 196,
                            column: 39
                        },
                        end: {
                            line: 196,
                            column: 86
                        }
                    }
                ],
                line: 195
            },
            "12": {
                loc: {
                    start: {
                        line: 213,
                        column: 4
                    },
                    end: {
                        line: 213,
                        column: 38
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 213,
                            column: 4
                        },
                        end: {
                            line: 213,
                            column: 38
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 213
            },
            "13": {
                loc: {
                    start: {
                        line: 216,
                        column: 4
                    },
                    end: {
                        line: 219,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 216,
                            column: 4
                        },
                        end: {
                            line: 219,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 216
            },
            "14": {
                loc: {
                    start: {
                        line: 222,
                        column: 4
                    },
                    end: {
                        line: 226,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 222,
                            column: 4
                        },
                        end: {
                            line: 226,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 224,
                            column: 11
                        },
                        end: {
                            line: 226,
                            column: 5
                        }
                    }
                ],
                line: 222
            },
            "15": {
                loc: {
                    start: {
                        line: 235,
                        column: 4
                    },
                    end: {
                        line: 237,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 235,
                            column: 4
                        },
                        end: {
                            line: 237,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 235
            },
            "16": {
                loc: {
                    start: {
                        line: 250,
                        column: 6
                    },
                    end: {
                        line: 260,
                        column: 12
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 251,
                            column: 10
                        },
                        end: {
                            line: 255,
                            column: 12
                        }
                    },
                    {
                        start: {
                            line: 256,
                            column: 10
                        },
                        end: {
                            line: 260,
                            column: 12
                        }
                    }
                ],
                line: 250
            },
            "17": {
                loc: {
                    start: {
                        line: 267,
                        column: 6
                    },
                    end: {
                        line: 274,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 267,
                            column: 6
                        },
                        end: {
                            line: 274,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 267
            },
            "18": {
                loc: {
                    start: {
                        line: 267,
                        column: 10
                    },
                    end: {
                        line: 267,
                        column: 47
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 267,
                            column: 10
                        },
                        end: {
                            line: 267,
                            column: 25
                        }
                    },
                    {
                        start: {
                            line: 267,
                            column: 29
                        },
                        end: {
                            line: 267,
                            column: 47
                        }
                    }
                ],
                line: 267
            },
            "19": {
                loc: {
                    start: {
                        line: 292,
                        column: 23
                    },
                    end: {
                        line: 292,
                        column: 65
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 292,
                            column: 30
                        },
                        end: {
                            line: 292,
                            column: 49
                        }
                    },
                    {
                        start: {
                            line: 292,
                            column: 52
                        },
                        end: {
                            line: 292,
                            column: 65
                        }
                    }
                ],
                line: 292
            },
            "20": {
                loc: {
                    start: {
                        line: 311,
                        column: 4
                    },
                    end: {
                        line: 318,
                        column: 6
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 311,
                            column: 4
                        },
                        end: {
                            line: 311,
                            column: 8
                        }
                    },
                    {
                        start: {
                            line: 312,
                            column: 5
                        },
                        end: {
                            line: 318,
                            column: 5
                        }
                    }
                ],
                line: 311
            },
            "21": {
                loc: {
                    start: {
                        line: 312,
                        column: 5
                    },
                    end: {
                        line: 318,
                        column: 5
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 313,
                            column: 6
                        },
                        end: {
                            line: 315,
                            column: 12
                        }
                    },
                    {
                        start: {
                            line: 317,
                            column: 6
                        },
                        end: {
                            line: 317,
                            column: 22
                        }
                    }
                ],
                line: 312
            },
            "22": {
                loc: {
                    start: {
                        line: 321,
                        column: 2
                    },
                    end: {
                        line: 331,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 321,
                            column: 2
                        },
                        end: {
                            line: 331,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 321
            },
            "23": {
                loc: {
                    start: {
                        line: 323,
                        column: 6
                    },
                    end: {
                        line: 327,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 323,
                            column: 6
                        },
                        end: {
                            line: 327,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: 325,
                            column: 13
                        },
                        end: {
                            line: 327,
                            column: 7
                        }
                    }
                ],
                line: 323
            },
            "24": {
                loc: {
                    start: {
                        line: 323,
                        column: 10
                    },
                    end: {
                        line: 323,
                        column: 46
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 323,
                            column: 10
                        },
                        end: {
                            line: 323,
                            column: 28
                        }
                    },
                    {
                        start: {
                            line: 323,
                            column: 32
                        },
                        end: {
                            line: 323,
                            column: 46
                        }
                    }
                ],
                line: 323
            },
            "25": {
                loc: {
                    start: {
                        line: 325,
                        column: 13
                    },
                    end: {
                        line: 327,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 325,
                            column: 13
                        },
                        end: {
                            line: 327,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 325
            },
            "26": {
                loc: {
                    start: {
                        line: 325,
                        column: 17
                    },
                    end: {
                        line: 325,
                        column: 76
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 325,
                            column: 17
                        },
                        end: {
                            line: 325,
                            column: 31
                        }
                    },
                    {
                        start: {
                            line: 325,
                            column: 35
                        },
                        end: {
                            line: 325,
                            column: 76
                        }
                    }
                ],
                line: 325
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0,
            "64": 0,
            "65": 0,
            "66": 0,
            "67": 0,
            "68": 0,
            "69": 0,
            "70": 0,
            "71": 0,
            "72": 0,
            "73": 0,
            "74": 0,
            "75": 0,
            "76": 0,
            "77": 0,
            "78": 0,
            "79": 0,
            "80": 0,
            "81": 0,
            "82": 0,
            "83": 0,
            "84": 0,
            "85": 0,
            "86": 0,
            "87": 0,
            "88": 0,
            "89": 0,
            "90": 0,
            "91": 0,
            "92": 0,
            "93": 0,
            "94": 0,
            "95": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0,
                0
            ],
            "4": [
                0,
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0,
                0,
                0
            ],
            "12": [
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0
            ],
            "15": [
                0,
                0
            ],
            "16": [
                0,
                0
            ],
            "17": [
                0,
                0
            ],
            "18": [
                0,
                0
            ],
            "19": [
                0,
                0
            ],
            "20": [
                0,
                0
            ],
            "21": [
                0,
                0
            ],
            "22": [
                0,
                0
            ],
            "23": [
                0,
                0
            ],
            "24": [
                0,
                0
            ],
            "25": [
                0,
                0
            ],
            "26": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "a6a2328d7a69b41fc72a7075499760680807594a"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_utly8d7bp = function cov_utly8d7bp() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_utly8d7bp();
function AddressInput_regenerator() {
    var i = function i(r, n, o, i1) {
        var c = n && (0,_instanceof/* default */.Z)(n.prototype, Generator) ? n : Generator, u = Object.create(c.prototype);
        return AddressInput_regeneratorDefine2(u, "_invoke", function(r, n, o) {
            var _$i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return _$i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !_$o && t < p.length; t++){
                    var _$o, _$i = p[t], _$d = G.p, l = _$i[2];
                    r > 3 ? (_$o = l === n) && (u = _$i[(c = _$i[4]) ? 5 : (c = 3, 3)], _$i[4] = _$i[5] = e) : _$i[0] <= _$d && ((_$o = r < 2 && _$d < _$i[1]) ? (c = 0, G.v = n, G.n = _$i[1]) : _$d < l && (_$o = r < 3 || _$i[0] > n || n > l) && (_$i[4] = r, _$i[5] = n, G.n = l, c = 0));
                }
                if (_$o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    _$i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, _$i) {
                            if (c || (o = "next"), t = _$i[o]) {
                                if (!(t = t.call(_$i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = _$i["return"]) && t.call(_$i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            _$i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t1) {
                        _$i = e, c = 1, u = t1;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i1), !0), u;
    };
    var Generator = function Generator() {};
    var GeneratorFunction = function GeneratorFunction() {};
    var GeneratorFunctionPrototype = function GeneratorFunctionPrototype() {};
    var f = function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, AddressInput_regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    };
    var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    var a = {};
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : (AddressInput_regeneratorDefine2(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, AddressInput_regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), AddressInput_regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", AddressInput_regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), AddressInput_regeneratorDefine2(u), AddressInput_regeneratorDefine2(u, o, "Generator"), AddressInput_regeneratorDefine2(u, n, function() {
        return this;
    }), AddressInput_regeneratorDefine2(u, "toString", function() {
        return "[object Generator]";
    }), (AddressInput_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    })();
}
function AddressInput_regeneratorDefine2(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e1) {
        i = 0;
    }
    AddressInput_regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
        var o = function o(r, n) {
            AddressInput_regeneratorDefine2(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        };
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, AddressInput_regeneratorDefine2(e, r, n, t);
}



























function AddressInput_asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n1) {
        return void e(n1);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function AddressInput_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                AddressInput_asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                AddressInput_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || AddressInput_unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function AddressInput_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return AddressInput_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? AddressInput_arrayLikeToArray(r, a) : void 0;
    }
}
function AddressInput_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}






var DEBOUNCE_INVOKE_WAIT_MS = (cov_utly8d7bp().s[0]++, 100);
/**
 * @param actionButton overrides `icon` in the suffix position when provided
 */ cov_utly8d7bp().s[1]++;
var AddressInput = function AddressInput(_ref) {
    var _ref8, _ref15;
    var id = _ref.id, placeholder = _ref.placeholder, disabled = _ref.disabled, hideLabel = _ref.hideLabel, label = _ref.label, value = _ref.value, onChange = _ref.onChange, defaultValue = _ref.defaultValue, _ref$fetchOnExternalV = _ref.fetchOnExternalValue, fetchOnExternalValue = _ref$fetchOnExternalV === void 0 ? (cov_utly8d7bp().b[0][0]++, false) : _ref$fetchOnExternalV, onAddressSelect = _ref.onAddressSelect, onAddressValidated = _ref.onAddressValidated, _ref$validateAddress = _ref.validateAddress, validateAddress = _ref$validateAddress === void 0 ? (cov_utly8d7bp().b[1][0]++, false) : _ref$validateAddress, onError = _ref.onError, onPredictionsChange = _ref.onPredictionsChange, onSearchTermChange = _ref.onSearchTermChange, onFocus = _ref.onFocus, onBlur = _ref.onBlur, customAction = _ref.customAction, listBoxId = _ref.listBoxId, listBoxAriaLabel = _ref.listBoxAriaLabel, icon = _ref.icon, actionButton = _ref.actionButton, size = _ref.size, supportText = _ref.supportText, errorText = _ref.errorText, invalid = _ref.invalid, required = _ref.required;
    cov_utly8d7bp().f[0]++;
    var _ref2 = (cov_utly8d7bp().s[2]++, (0,react.useState)([])), _ref3 = _slicedToArray(_ref2, 2), predictions = _ref3[0], setPredictions = _ref3[1];
    var _ref4 = (cov_utly8d7bp().s[3]++, (0,react.useState)(null)), _ref5 = _slicedToArray(_ref4, 2), usedPrediction = _ref5[0], setUsedPrediction = _ref5[1];
    var _ref6 = (cov_utly8d7bp().s[4]++, (0,react.useState)((_ref8 = (cov_utly8d7bp().b[2][0]++, defaultValue)) !== null && _ref8 !== void 0 ? _ref8 : (cov_utly8d7bp().b[2][1]++, ""))), _ref7 = _slicedToArray(_ref6, 2), internalSearchTerm = _ref7[0], setInternalSearchTerm = _ref7[1];
    var _ref9 = (cov_utly8d7bp().s[5]++, (0,react.useState)(false)), _ref0 = _slicedToArray(_ref9, 2), isLoading = _ref0[0], setIsLoading = _ref0[1];
    var _ref1 = (cov_utly8d7bp().s[6]++, (0,react.useState)(function() {
        cov_utly8d7bp().f[1]++;
        cov_utly8d7bp().s[7]++;
        return (0,googleMaps/* generateGoogleMapsSessionToken */.h_)();
    })), _ref10 = _slicedToArray(_ref1, 1), sessionToken = _ref10[0];
    var inputRef = (cov_utly8d7bp().s[8]++, (0,react.useRef)(null));
    var didMountRef = (cov_utly8d7bp().s[9]++, (0,react.useRef)(false));
    // Determine if component is controlled (value prop is provided)
    var isControlled = (cov_utly8d7bp().s[10]++, value !== undefined);
    var searchTerm = (cov_utly8d7bp().s[11]++, isControlled ? (cov_utly8d7bp().b[3][0]++, value) : (cov_utly8d7bp().b[3][1]++, internalSearchTerm));
    cov_utly8d7bp().s[12]++;
    var updateSearchTerm = function updateSearchTerm(newValue) {
        cov_utly8d7bp().f[2]++;
        cov_utly8d7bp().s[13]++;
        if (!isControlled) {
            cov_utly8d7bp().b[4][0]++;
            cov_utly8d7bp().s[14]++;
            setInternalSearchTerm(newValue);
        } else {
            cov_utly8d7bp().b[4][1]++;
        }
        cov_utly8d7bp().s[15]++;
        onChange === null || onChange === void 0 || onChange(newValue);
    };
    cov_utly8d7bp().s[16]++;
    (0,react.useEffect)(function() {
        cov_utly8d7bp().f[3]++;
        cov_utly8d7bp().s[17]++;
        onPredictionsChange === null || onPredictionsChange === void 0 || onPredictionsChange(predictions);
    }, [
        predictions,
        onPredictionsChange
    ]);
    // For uncontrolled mode, notify on initial mount and when defaultValue changes
    // For controlled mode, the parent already knows the value
    cov_utly8d7bp().s[18]++;
    (0,react.useEffect)(function() {
        cov_utly8d7bp().f[4]++;
        cov_utly8d7bp().s[19]++;
        if (!isControlled) {
            cov_utly8d7bp().b[5][0]++;
            cov_utly8d7bp().s[20]++;
            onSearchTermChange === null || onSearchTermChange === void 0 || onSearchTermChange(searchTerm);
        } else {
            cov_utly8d7bp().b[5][1]++;
        }
    }, [
        isControlled,
        searchTerm,
        onSearchTermChange
    ]);
    cov_utly8d7bp().s[21]++;
    var clearPredictions = function clearPredictions() {
        cov_utly8d7bp().f[5]++;
        cov_utly8d7bp().s[22]++;
        setUsedPrediction(null);
        cov_utly8d7bp().s[23]++;
        setPredictions([]);
    };
    var fetchAutocompleteOptions = (cov_utly8d7bp().s[24]++, (0,react.useMemo)(function() {
        cov_utly8d7bp().f[6]++;
        cov_utly8d7bp().s[25]++;
        return debounce_default()(/*#__PURE__*/ function() {
            var _ref11 = AddressInput_asyncToGenerator(/*#__PURE__*/ AddressInput_regenerator().m(function _callee(input) {
                var response, data, filtered, _t;
                return AddressInput_regenerator().w(function(_context) {
                    while(1)switch(_context.p = _context.n){
                        case 0:
                            cov_utly8d7bp().f[7]++;
                            cov_utly8d7bp().s[26]++;
                            if (input) {
                                _context.n = 1;
                                break;
                            }
                            cov_utly8d7bp().b[6][0]++;
                            cov_utly8d7bp().s[27]++;
                            clearPredictions();
                            cov_utly8d7bp().s[28]++;
                            return _context.a(2);
                        case 1:
                            cov_utly8d7bp().b[6][1]++;
                        case 2:
                            cov_utly8d7bp().s[29]++;
                            _context.p = 3;
                            cov_utly8d7bp().s[30]++;
                            _context.n = 4;
                            return fetch((0,googleMaps/* buildAutocompleteUrl */.Iz)(input, sessionToken));
                        case 4:
                            response = _context.v;
                            cov_utly8d7bp().s[31]++;
                            _context.n = 5;
                            return response.json();
                        case 5:
                            data = _context.v;
                            cov_utly8d7bp().s[32]++;
                            // Clean descriptions by removing ', USA' and add required AutocompleteItem properties
                            data.predictions.forEach(function(result) {
                                cov_utly8d7bp().f[8]++;
                                cov_utly8d7bp().s[33]++;
                                result.description = result.description.replace(", USA", "");
                                cov_utly8d7bp().s[34]++;
                                result.id = (cov_utly8d7bp().b[7][0]++, result.place_id) || (cov_utly8d7bp().b[7][1]++, result.addressToken) || (cov_utly8d7bp().b[7][2]++, result.description);
                                cov_utly8d7bp().s[35]++;
                                result.ariaLabel = result.description;
                            });
                            // Filter predictions based on type and term count
                            filtered = (cov_utly8d7bp().s[36]++, data.predictions.filter(function(result) {
                                cov_utly8d7bp().f[9]++;
                                cov_utly8d7bp().s[37]++;
                                result.source = data.source;
                                cov_utly8d7bp().s[38]++;
                                if (data.source === "google") {
                                    var _ref12, _ref13;
                                    cov_utly8d7bp().b[8][0]++;
                                    var terms = (cov_utly8d7bp().s[39]++, (_ref12 = (cov_utly8d7bp().b[9][0]++, result.terms)) !== null && _ref12 !== void 0 ? _ref12 : (cov_utly8d7bp().b[9][1]++, []));
                                    var allowedTypes = (cov_utly8d7bp().s[40]++, ((_ref13 = (cov_utly8d7bp().b[10][0]++, result.types)) !== null && _ref13 !== void 0 ? _ref13 : (cov_utly8d7bp().b[10][1]++, [])).filter(function(type) {
                                        cov_utly8d7bp().f[10]++;
                                        cov_utly8d7bp().s[41]++;
                                        return googleMaps/* ALLOWED_TYPES.includes */.MF.includes(type);
                                    }));
                                    cov_utly8d7bp().s[42]++;
                                    return (cov_utly8d7bp().b[11][0]++, terms.length >= 5) && (cov_utly8d7bp().b[11][1]++, allowedTypes.length > 0) || (cov_utly8d7bp().b[11][2]++, terms.length === 4) && (cov_utly8d7bp().b[11][3]++, terms[0].value.match(/^\d+\S*\s\S+\s/) !== null);
                                } else {
                                    cov_utly8d7bp().b[8][1]++;
                                }
                                cov_utly8d7bp().s[43]++;
                                return true;
                            }));
                            cov_utly8d7bp().s[44]++;
                            setPredictions(filtered);
                            _context.n = 7;
                            break;
                        case 6:
                            _context.p = 6;
                            _t = _context.v;
                            cov_utly8d7bp().s[45]++;
                            clearPredictions();
                            cov_utly8d7bp().s[46]++;
                            onError === null || onError === void 0 || onError(_t);
                        case 7:
                            return _context.a(2);
                    }
                }, _callee, null, [
                    [
                        3,
                        6
                    ]
                ]);
            }));
            return function(_x) {
                return _ref11.apply(this, arguments);
            };
        }(), DEBOUNCE_INVOKE_WAIT_MS);
    }, [
        sessionToken,
        onError
    ]));
    // Handle external value changes when fetchOnExternalValue is enabled
    cov_utly8d7bp().s[47]++;
    (0,react.useEffect)(function() {
        cov_utly8d7bp().f[11]++;
        cov_utly8d7bp().s[48]++;
        if (!fetchOnExternalValue) {
            cov_utly8d7bp().b[12][0]++;
            cov_utly8d7bp().s[49]++;
            return;
        } else {
            cov_utly8d7bp().b[12][1]++;
        }
        // Skip initial mount - only react to subsequent changes
        cov_utly8d7bp().s[50]++;
        if (!didMountRef.current) {
            cov_utly8d7bp().b[13][0]++;
            cov_utly8d7bp().s[51]++;
            didMountRef.current = true;
            cov_utly8d7bp().s[52]++;
            return;
        } else {
            cov_utly8d7bp().b[13][1]++;
        }
        // Sync predictions based on external value change
        cov_utly8d7bp().s[53]++;
        if (searchTerm === "") {
            cov_utly8d7bp().b[14][0]++;
            cov_utly8d7bp().s[54]++;
            clearPredictions();
        } else {
            cov_utly8d7bp().b[14][1]++;
            cov_utly8d7bp().s[55]++;
            fetchAutocompleteOptions(searchTerm);
        }
    // clearPredictions is stable (no external dependencies), safe to omit
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchOnExternalValue,
        searchTerm,
        fetchAutocompleteOptions
    ]);
    cov_utly8d7bp().s[56]++;
    var handleInputChange = function handleInputChange(e) {
        cov_utly8d7bp().f[12]++;
        var newValue = (cov_utly8d7bp().s[57]++, e.target.value);
        cov_utly8d7bp().s[58]++;
        updateSearchTerm(newValue);
        cov_utly8d7bp().s[59]++;
        fetchAutocompleteOptions(newValue);
        cov_utly8d7bp().s[60]++;
        if (newValue === "") {
            cov_utly8d7bp().b[15][0]++;
            cov_utly8d7bp().s[61]++;
            clearPredictions();
        } else {
            cov_utly8d7bp().b[15][1]++;
        }
    };
    cov_utly8d7bp().s[62]++;
    var handlePredictionSelect = /*#__PURE__*/ function() {
        var _ref14 = AddressInput_asyncToGenerator(/*#__PURE__*/ AddressInput_regenerator().m(function _callee2(prediction) {
            var _inputRef$current;
            var url, response, address, validationResult, _t2, _t3;
            return AddressInput_regenerator().w(function(_context2) {
                while(1)switch(_context2.p = _context2.n){
                    case 0:
                        cov_utly8d7bp().f[13]++;
                        cov_utly8d7bp().s[63]++;
                        // Blur input to dismiss keyboard before async operations that may open modals
                        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
                        cov_utly8d7bp().s[64]++;
                        setUsedPrediction(prediction);
                        cov_utly8d7bp().s[65]++;
                        updateSearchTerm(prediction.description);
                        cov_utly8d7bp().s[66]++;
                        setPredictions([]);
                        cov_utly8d7bp().s[67]++;
                        setIsLoading(true);
                        url = (cov_utly8d7bp().s[68]++, prediction.source === "google" ? (cov_utly8d7bp().b[16][0]++, (0,googleMaps/* buildPlacesUrl */.dl)({
                            source: "google",
                            placeId: prediction.place_id,
                            sessionToken: sessionToken
                        })) : (cov_utly8d7bp().b[16][1]++, (0,googleMaps/* buildPlacesUrl */.dl)({
                            source: "casa",
                            addressToken: prediction.addressToken,
                            sessionToken: sessionToken
                        })));
                        cov_utly8d7bp().s[69]++;
                        _context2.p = 1;
                        cov_utly8d7bp().s[70]++;
                        _context2.n = 2;
                        return fetch(url);
                    case 2:
                        response = _context2.v;
                        cov_utly8d7bp().s[71]++;
                        _context2.n = 3;
                        return response.json();
                    case 3:
                        address = _context2.v;
                        cov_utly8d7bp().s[72]++;
                        if (!((cov_utly8d7bp().b[18][0]++, validateAddress) && (cov_utly8d7bp().b[18][1]++, onAddressValidated))) {
                            _context2.n = 8;
                            break;
                        }
                        cov_utly8d7bp().b[17][0]++;
                        cov_utly8d7bp().s[73]++;
                        _context2.p = 4;
                        cov_utly8d7bp().s[74]++;
                        _context2.n = 5;
                        return addressValidation_validateAddress(address);
                    case 5:
                        validationResult = _context2.v;
                        cov_utly8d7bp().s[75]++;
                        onAddressValidated(validationResult);
                        _context2.n = 7;
                        break;
                    case 6:
                        _context2.p = 6;
                        _t2 = _context2.v;
                        cov_utly8d7bp().s[76]++;
                        onError === null || onError === void 0 || onError(_t2);
                    case 7:
                        _context2.n = 9;
                        break;
                    case 8:
                        cov_utly8d7bp().b[17][1]++;
                    case 9:
                        cov_utly8d7bp().s[77]++;
                        onAddressSelect(address);
                        _context2.n = 11;
                        break;
                    case 10:
                        _context2.p = 10;
                        _t3 = _context2.v;
                        cov_utly8d7bp().s[78]++;
                        onError === null || onError === void 0 || onError(_t3);
                    case 11:
                        _context2.p = 11;
                        cov_utly8d7bp().s[79]++;
                        setIsLoading(false);
                        return _context2.f(11);
                    case 12:
                        return _context2.a(2);
                }
            }, _callee2, null, [
                [
                    4,
                    6
                ],
                [
                    1,
                    10,
                    11,
                    12
                ]
            ]);
        }));
        return function handlePredictionSelect(_x2) {
            return _ref14.apply(this, arguments);
        };
    }();
    cov_utly8d7bp().s[80]++;
    var renderItem = function renderItem(prediction) {
        cov_utly8d7bp().f[14]++;
        // Map size to typography for consistent styling
        var typographyMap = (cov_utly8d7bp().s[81]++, {
            xsmall: "$bodyMedium",
            small: "$bodyMedium",
            medium: "$bodyLarge",
            large: "$bodyXlarge"
        });
        var typography = (cov_utly8d7bp().s[82]++, size ? (cov_utly8d7bp().b[19][0]++, typographyMap[size]) : (cov_utly8d7bp().b[19][1]++, "$bodyXlarge"));
        cov_utly8d7bp().s[83]++;
        return /*#__PURE__*/ react.createElement(Text/* Text */.x, {
            typography: typography,
            tag: "span",
            textAlign: "left",
            $smallerThanMD: {
                typography: "$bodyMedium"
            },
            px: 10,
            py: 2
        }, prediction.description);
    };
    var displayIcon = (cov_utly8d7bp().s[84]++, (_ref15 = (cov_utly8d7bp().b[20][0]++, icon)) !== null && _ref15 !== void 0 ? _ref15 : (cov_utly8d7bp().b[20][1]++, isLoading ? (cov_utly8d7bp().b[21][0]++, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        position: "relative",
        px: "$4",
        display: "block"
    }, /*#__PURE__*/ react.createElement(Button/* ButtonLoadingAnimation */.V, {
        variant: "secondary",
        size: "xsmall"
    }))) : (cov_utly8d7bp().b[21][1]++, /*#__PURE__*/ react.createElement(Search/* default */.Z, null))));
    var useSuffix = (cov_utly8d7bp().s[85]++, displayIcon);
    cov_utly8d7bp().s[86]++;
    if (actionButton) {
        cov_utly8d7bp().b[22][0]++;
        cov_utly8d7bp().s[87]++;
        var onPress = function onPress() {
            cov_utly8d7bp().f[15]++;
            cov_utly8d7bp().s[88]++;
            if ((cov_utly8d7bp().b[24][0]++, predictions.length) && (cov_utly8d7bp().b[24][1]++, predictions[0])) {
                cov_utly8d7bp().b[23][0]++;
                cov_utly8d7bp().s[89]++;
                handlePredictionSelect(predictions[0]);
            } else {
                cov_utly8d7bp().b[23][1]++;
                cov_utly8d7bp().s[90]++;
                if ((cov_utly8d7bp().b[26][0]++, usedPrediction) && (cov_utly8d7bp().b[26][1]++, searchTerm === usedPrediction.description)) {
                    cov_utly8d7bp().b[25][0]++;
                    cov_utly8d7bp().s[91]++;
                    handlePredictionSelect(usedPrediction);
                } else {
                    cov_utly8d7bp().b[25][1]++;
                }
            }
        };
        var renderedButton = (cov_utly8d7bp().s[92]++, actionButton(onPress, isLoading));
        cov_utly8d7bp().s[93]++;
        useSuffix = renderedButton;
    } else {
        cov_utly8d7bp().b[22][1]++;
    }
    cov_utly8d7bp().s[94]++;
    return /*#__PURE__*/ react.createElement(AutocompleteInput/* default */.Z, {
        id: id,
        label: label,
        hideLabel: hideLabel,
        placeholder: placeholder,
        disabled: disabled,
        items: predictions,
        searchTerm: searchTerm,
        onSearchChange: handleInputChange,
        onItemSelect: handlePredictionSelect,
        renderItem: renderItem,
        suffix: useSuffix,
        customAction: customAction,
        listBoxId: listBoxId,
        onEscape: function onEscape() {
            cov_utly8d7bp().f[16]++;
            cov_utly8d7bp().s[95]++;
            return clearPredictions();
        },
        onFocus: onFocus,
        onBlur: onBlur,
        listBoxAriaLabel: listBoxAriaLabel,
        size: size,
        supportText: supportText,
        errorText: errorText,
        invalid: invalid,
        required: required,
        inputRef: inputRef
    });
};
/* harmony default export */ var AddressInput_AddressInput = (AddressInput); //# sourceMappingURL=AddressInput.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AddressInput/index.mjs
function cov_77t8qvh2w() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/core/AddressInput/index.ts";
    var hash = "937c1a188ed009a7e90602a44c835b5738ee9a03";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/core/AddressInput/index.ts",
        statementMap: {},
        fnMap: {},
        branchMap: {},
        s: {},
        f: {},
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "937c1a188ed009a7e90602a44c835b5738ee9a03"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_77t8qvh2w = function cov_77t8qvh2w() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_77t8qvh2w();
 //# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 59801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ AutocompleteInput_AutocompleteInput; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(41817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(32165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(91038);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(66992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(47042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(68309);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(77601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(39714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(78783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__(19601);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(41539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(33948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.constructor.js
var esnext_iterator_constructor = __webpack_require__(2490);
// EXTERNAL MODULE: ./node_modules/core-js/modules/esnext.iterator.map.js
var esnext_iterator_map = __webpack_require__(9924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/inputs/TextInput.js
var TextInput = __webpack_require__(94746);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AutocompleteInput/AutocompleteInput.mjs





function cov_19j15inqim() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/AutocompleteInput.tsx";
    var hash = "07e7abcc1d9f196d2ac5b7463687882d6b942e86";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/AutocompleteInput.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 63,
                    column: 23
                },
                end: {
                    line: 65,
                    column: 2
                }
            },
            "1": {
                start: {
                    line: 64,
                    column: 2
                },
                end: {
                    line: 64,
                    column: 46
                }
            },
            "2": {
                start: {
                    line: 67,
                    column: 26
                },
                end: {
                    line: 122,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 79,
                    column: 26
                },
                end: {
                    line: 83,
                    column: 12
                }
            },
            "4": {
                start: {
                    line: 84,
                    column: 23
                },
                end: {
                    line: 84,
                    column: 85
                }
            },
            "5": {
                start: {
                    line: 86,
                    column: 2
                },
                end: {
                    line: 121,
                    column: 4
                }
            },
            "6": {
                start: {
                    line: 124,
                    column: 26
                },
                end: {
                    line: 317,
                    column: 1
                }
            },
            "7": {
                start: {
                    line: 149,
                    column: 44
                },
                end: {
                    line: 149,
                    column: 83
                }
            },
            "8": {
                start: {
                    line: 150,
                    column: 36
                },
                end: {
                    line: 150,
                    column: 51
                }
            },
            "9": {
                start: {
                    line: 151,
                    column: 24
                },
                end: {
                    line: 151,
                    column: 28
                }
            },
            "10": {
                start: {
                    line: 152,
                    column: 27
                },
                end: {
                    line: 152,
                    column: 57
                }
            },
            "11": {
                start: {
                    line: 153,
                    column: 19
                },
                end: {
                    line: 153,
                    column: 55
                }
            },
            "12": {
                start: {
                    line: 156,
                    column: 2
                },
                end: {
                    line: 160,
                    column: 29
                }
            },
            "13": {
                start: {
                    line: 157,
                    column: 4
                },
                end: {
                    line: 159,
                    column: 5
                }
            },
            "14": {
                start: {
                    line: 158,
                    column: 6
                },
                end: {
                    line: 158,
                    column: 34
                }
            },
            "15": {
                start: {
                    line: 162,
                    column: 27
                },
                end: {
                    line: 168,
                    column: 3
                }
            },
            "16": {
                start: {
                    line: 163,
                    column: 17
                },
                end: {
                    line: 166,
                    column: 5
                }
            },
            "17": {
                start: {
                    line: 164,
                    column: 6
                },
                end: {
                    line: 164,
                    column: 25
                }
            },
            "18": {
                start: {
                    line: 165,
                    column: 6
                },
                end: {
                    line: 165,
                    column: 31
                }
            },
            "19": {
                start: {
                    line: 170,
                    column: 80
                },
                end: {
                    line: 197,
                    column: 3
                }
            },
            "20": {
                start: {
                    line: 171,
                    column: 4
                },
                end: {
                    line: 196,
                    column: 5
                }
            },
            "21": {
                start: {
                    line: 172,
                    column: 6
                },
                end: {
                    line: 172,
                    column: 25
                }
            },
            "22": {
                start: {
                    line: 173,
                    column: 6
                },
                end: {
                    line: 177,
                    column: 7
                }
            },
            "23": {
                start: {
                    line: 175,
                    column: 10
                },
                end: {
                    line: 175,
                    column: 99
                }
            },
            "24": {
                start: {
                    line: 176,
                    column: 8
                },
                end: {
                    line: 176,
                    column: 43
                }
            },
            "25": {
                start: {
                    line: 178,
                    column: 11
                },
                end: {
                    line: 196,
                    column: 5
                }
            },
            "26": {
                start: {
                    line: 179,
                    column: 6
                },
                end: {
                    line: 179,
                    column: 25
                }
            },
            "27": {
                start: {
                    line: 180,
                    column: 6
                },
                end: {
                    line: 184,
                    column: 7
                }
            },
            "28": {
                start: {
                    line: 182,
                    column: 10
                },
                end: {
                    line: 182,
                    column: 99
                }
            },
            "29": {
                start: {
                    line: 183,
                    column: 8
                },
                end: {
                    line: 183,
                    column: 43
                }
            },
            "30": {
                start: {
                    line: 185,
                    column: 11
                },
                end: {
                    line: 196,
                    column: 5
                }
            },
            "31": {
                start: {
                    line: 186,
                    column: 6
                },
                end: {
                    line: 186,
                    column: 25
                }
            },
            "32": {
                start: {
                    line: 187,
                    column: 6
                },
                end: {
                    line: 190,
                    column: 7
                }
            },
            "33": {
                start: {
                    line: 188,
                    column: 8
                },
                end: {
                    line: 188,
                    column: 43
                }
            },
            "34": {
                start: {
                    line: 189,
                    column: 8
                },
                end: {
                    line: 189,
                    column: 33
                }
            },
            "35": {
                start: {
                    line: 191,
                    column: 11
                },
                end: {
                    line: 196,
                    column: 5
                }
            },
            "36": {
                start: {
                    line: 192,
                    column: 6
                },
                end: {
                    line: 192,
                    column: 34
                }
            },
            "37": {
                start: {
                    line: 193,
                    column: 6
                },
                end: {
                    line: 193,
                    column: 19
                }
            },
            "38": {
                start: {
                    line: 195,
                    column: 6
                },
                end: {
                    line: 195,
                    column: 34
                }
            },
            "39": {
                start: {
                    line: 199,
                    column: 30
                },
                end: {
                    line: 207,
                    column: 3
                }
            },
            "40": {
                start: {
                    line: 201,
                    column: 6
                },
                end: {
                    line: 204,
                    column: 7
                }
            },
            "41": {
                start: {
                    line: 202,
                    column: 8
                },
                end: {
                    line: 202,
                    column: 28
                }
            },
            "42": {
                start: {
                    line: 203,
                    column: 8
                },
                end: {
                    line: 203,
                    column: 19
                }
            },
            "43": {
                start: {
                    line: 209,
                    column: 31
                },
                end: {
                    line: 212,
                    column: 15
                }
            },
            "44": {
                start: {
                    line: 210,
                    column: 4
                },
                end: {
                    line: 210,
                    column: 23
                }
            },
            "45": {
                start: {
                    line: 211,
                    column: 4
                },
                end: {
                    line: 211,
                    column: 16
                }
            },
            "46": {
                start: {
                    line: 214,
                    column: 26
                },
                end: {
                    line: 216,
                    column: 8
                }
            },
            "47": {
                start: {
                    line: 215,
                    column: 4
                },
                end: {
                    line: 215,
                    column: 23
                }
            },
            "48": {
                start: {
                    line: 218,
                    column: 23
                },
                end: {
                    line: 218,
                    column: 53
                }
            },
            "49": {
                start: {
                    line: 220,
                    column: 2
                },
                end: {
                    line: 314,
                    column: 3
                }
            },
            "50": {
                start: {
                    line: 221,
                    column: 32
                },
                end: {
                    line: 243,
                    column: 5
                }
            },
            "51": {
                start: {
                    line: 227,
                    column: 31
                },
                end: {
                    line: 229,
                    column: 48
                }
            },
            "52": {
                start: {
                    line: 230,
                    column: 8
                },
                end: {
                    line: 230,
                    column: 39
                }
            },
            "53": {
                start: {
                    line: 245,
                    column: 4
                },
                end: {
                    line: 251,
                    column: 5
                }
            },
            "54": {
                start: {
                    line: 246,
                    column: 6
                },
                end: {
                    line: 246,
                    column: 35
                }
            },
            "55": {
                start: {
                    line: 247,
                    column: 11
                },
                end: {
                    line: 251,
                    column: 5
                }
            },
            "56": {
                start: {
                    line: 248,
                    column: 6
                },
                end: {
                    line: 248,
                    column: 39
                }
            },
            "57": {
                start: {
                    line: 250,
                    column: 6
                },
                end: {
                    line: 250,
                    column: 48
                }
            },
            "58": {
                start: {
                    line: 254,
                    column: 4
                },
                end: {
                    line: 260,
                    column: 5
                }
            },
            "59": {
                start: {
                    line: 255,
                    column: 6
                },
                end: {
                    line: 259,
                    column: 8
                }
            },
            "60": {
                start: {
                    line: 262,
                    column: 4
                },
                end: {
                    line: 313,
                    column: 6
                }
            },
            "61": {
                start: {
                    line: 271,
                    column: 35
                },
                end: {
                    line: 271,
                    column: 58
                }
            },
            "62": {
                start: {
                    line: 273,
                    column: 16
                },
                end: {
                    line: 306,
                    column: 18
                }
            },
            "63": {
                start: {
                    line: 316,
                    column: 2
                },
                end: {
                    line: 316,
                    column: 14
                }
            }
        },
        fnMap: {
            "0": {
                name: "ListBoxElement",
                decl: {
                    start: {
                        line: 63,
                        column: 49
                    },
                    end: {
                        line: 63,
                        column: 63
                    }
                },
                loc: {
                    start: {
                        line: 63,
                        column: 90
                    },
                    end: {
                        line: 65,
                        column: 1
                    }
                },
                line: 63
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 67,
                        column: 26
                    },
                    end: {
                        line: 67,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 77,
                        column: 6
                    },
                    end: {
                        line: 122,
                        column: 1
                    }
                },
                line: 77
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 124,
                        column: 26
                    },
                    end: {
                        line: 124,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 148,
                        column: 33
                    },
                    end: {
                        line: 317,
                        column: 1
                    }
                },
                line: 148
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 156,
                        column: 12
                    },
                    end: {
                        line: 156,
                        column: 13
                    }
                },
                loc: {
                    start: {
                        line: 156,
                        column: 18
                    },
                    end: {
                        line: 160,
                        column: 3
                    }
                },
                line: 156
            },
            "4": {
                name: "(anonymous_4)",
                decl: {
                    start: {
                        line: 163,
                        column: 4
                    },
                    end: {
                        line: 163,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 163,
                        column: 17
                    },
                    end: {
                        line: 166,
                        column: 5
                    }
                },
                line: 163
            },
            "5": {
                name: "(anonymous_5)",
                decl: {
                    start: {
                        line: 163,
                        column: 17
                    },
                    end: {
                        line: 163,
                        column: 18
                    }
                },
                loc: {
                    start: {
                        line: 163,
                        column: 23
                    },
                    end: {
                        line: 166,
                        column: 5
                    }
                },
                line: 163
            },
            "6": {
                name: "(anonymous_6)",
                decl: {
                    start: {
                        line: 170,
                        column: 80
                    },
                    end: {
                        line: 170,
                        column: 81
                    }
                },
                loc: {
                    start: {
                        line: 170,
                        column: 87
                    },
                    end: {
                        line: 197,
                        column: 3
                    }
                },
                line: 170
            },
            "7": {
                name: "(anonymous_7)",
                decl: {
                    start: {
                        line: 200,
                        column: 4
                    },
                    end: {
                        line: 200,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 200,
                        column: 45
                    },
                    end: {
                        line: 205,
                        column: 5
                    }
                },
                line: 200
            },
            "8": {
                name: "(anonymous_8)",
                decl: {
                    start: {
                        line: 209,
                        column: 43
                    },
                    end: {
                        line: 209,
                        column: 44
                    }
                },
                loc: {
                    start: {
                        line: 209,
                        column: 49
                    },
                    end: {
                        line: 212,
                        column: 3
                    }
                },
                line: 209
            },
            "9": {
                name: "(anonymous_9)",
                decl: {
                    start: {
                        line: 214,
                        column: 38
                    },
                    end: {
                        line: 214,
                        column: 39
                    }
                },
                loc: {
                    start: {
                        line: 214,
                        column: 63
                    },
                    end: {
                        line: 216,
                        column: 3
                    }
                },
                line: 214
            },
            "10": {
                name: "(anonymous_10)",
                decl: {
                    start: {
                        line: 226,
                        column: 20
                    },
                    end: {
                        line: 226,
                        column: 21
                    }
                },
                loc: {
                    start: {
                        line: 226,
                        column: 38
                    },
                    end: {
                        line: 231,
                        column: 7
                    }
                },
                line: 226
            },
            "11": {
                name: "(anonymous_11)",
                decl: {
                    start: {
                        line: 270,
                        column: 25
                    },
                    end: {
                        line: 270,
                        column: 26
                    }
                },
                loc: {
                    start: {
                        line: 270,
                        column: 42
                    },
                    end: {
                        line: 307,
                        column: 15
                    }
                },
                line: 270
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 70,
                        column: 2
                    },
                    end: {
                        line: 70,
                        column: 27
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 70,
                            column: 14
                        },
                        end: {
                            line: 70,
                            column: 27
                        }
                    }
                ],
                line: 70
            },
            "1": {
                loc: {
                    start: {
                        line: 71,
                        column: 2
                    },
                    end: {
                        line: 71,
                        column: 17
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 71,
                            column: 9
                        },
                        end: {
                            line: 71,
                            column: 17
                        }
                    }
                ],
                line: 71
            },
            "2": {
                loc: {
                    start: {
                        line: 84,
                        column: 23
                    },
                    end: {
                        line: 84,
                        column: 85
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 84,
                            column: 23
                        },
                        end: {
                            line: 84,
                            column: 76
                        }
                    },
                    {
                        start: {
                            line: 84,
                            column: 80
                        },
                        end: {
                            line: 84,
                            column: 85
                        }
                    }
                ],
                line: 84
            },
            "3": {
                loc: {
                    start: {
                        line: 137,
                        column: 2
                    },
                    end: {
                        line: 137,
                        column: 36
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 137,
                            column: 14
                        },
                        end: {
                            line: 137,
                            column: 36
                        }
                    }
                ],
                line: 137
            },
            "4": {
                loc: {
                    start: {
                        line: 142,
                        column: 2
                    },
                    end: {
                        line: 142,
                        column: 17
                    }
                },
                type: "default-arg",
                locations: [
                    {
                        start: {
                            line: 142,
                            column: 9
                        },
                        end: {
                            line: 142,
                            column: 17
                        }
                    }
                ],
                line: 142
            },
            "5": {
                loc: {
                    start: {
                        line: 153,
                        column: 19
                    },
                    end: {
                        line: 153,
                        column: 55
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 153,
                            column: 19
                        },
                        end: {
                            line: 153,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 153,
                            column: 39
                        },
                        end: {
                            line: 153,
                            column: 55
                        }
                    }
                ],
                line: 153
            },
            "6": {
                loc: {
                    start: {
                        line: 157,
                        column: 4
                    },
                    end: {
                        line: 159,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 157,
                            column: 4
                        },
                        end: {
                            line: 159,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 157
            },
            "7": {
                loc: {
                    start: {
                        line: 157,
                        column: 8
                    },
                    end: {
                        line: 157,
                        column: 68
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 157,
                            column: 8
                        },
                        end: {
                            line: 157,
                            column: 35
                        }
                    },
                    {
                        start: {
                            line: 157,
                            column: 39
                        },
                        end: {
                            line: 157,
                            column: 68
                        }
                    }
                ],
                line: 157
            },
            "8": {
                loc: {
                    start: {
                        line: 171,
                        column: 4
                    },
                    end: {
                        line: 196,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 171,
                            column: 4
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 178,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    }
                ],
                line: 171
            },
            "9": {
                loc: {
                    start: {
                        line: 173,
                        column: 6
                    },
                    end: {
                        line: 177,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 173,
                            column: 6
                        },
                        end: {
                            line: 177,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 173
            },
            "10": {
                loc: {
                    start: {
                        line: 175,
                        column: 10
                    },
                    end: {
                        line: 175,
                        column: 99
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 175,
                            column: 78
                        },
                        end: {
                            line: 175,
                            column: 79
                        }
                    },
                    {
                        start: {
                            line: 175,
                            column: 82
                        },
                        end: {
                            line: 175,
                            column: 99
                        }
                    }
                ],
                line: 175
            },
            "11": {
                loc: {
                    start: {
                        line: 175,
                        column: 10
                    },
                    end: {
                        line: 175,
                        column: 75
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 175,
                            column: 10
                        },
                        end: {
                            line: 175,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 175,
                            column: 41
                        },
                        end: {
                            line: 175,
                            column: 75
                        }
                    }
                ],
                line: 175
            },
            "12": {
                loc: {
                    start: {
                        line: 178,
                        column: 11
                    },
                    end: {
                        line: 196,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 178,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 185,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    }
                ],
                line: 178
            },
            "13": {
                loc: {
                    start: {
                        line: 180,
                        column: 6
                    },
                    end: {
                        line: 184,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 180,
                            column: 6
                        },
                        end: {
                            line: 184,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 180
            },
            "14": {
                loc: {
                    start: {
                        line: 182,
                        column: 10
                    },
                    end: {
                        line: 182,
                        column: 99
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 182,
                            column: 63
                        },
                        end: {
                            line: 182,
                            column: 79
                        }
                    },
                    {
                        start: {
                            line: 182,
                            column: 82
                        },
                        end: {
                            line: 182,
                            column: 99
                        }
                    }
                ],
                line: 182
            },
            "15": {
                loc: {
                    start: {
                        line: 182,
                        column: 10
                    },
                    end: {
                        line: 182,
                        column: 60
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 182,
                            column: 10
                        },
                        end: {
                            line: 182,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 182,
                            column: 41
                        },
                        end: {
                            line: 182,
                            column: 60
                        }
                    }
                ],
                line: 182
            },
            "16": {
                loc: {
                    start: {
                        line: 185,
                        column: 11
                    },
                    end: {
                        line: 196,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 185,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 191,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    }
                ],
                line: 185
            },
            "17": {
                loc: {
                    start: {
                        line: 187,
                        column: 6
                    },
                    end: {
                        line: 190,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 187,
                            column: 6
                        },
                        end: {
                            line: 190,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 187
            },
            "18": {
                loc: {
                    start: {
                        line: 187,
                        column: 10
                    },
                    end: {
                        line: 187,
                        column: 61
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 187,
                            column: 10
                        },
                        end: {
                            line: 187,
                            column: 37
                        }
                    },
                    {
                        start: {
                            line: 187,
                            column: 41
                        },
                        end: {
                            line: 187,
                            column: 61
                        }
                    }
                ],
                line: 187
            },
            "19": {
                loc: {
                    start: {
                        line: 191,
                        column: 11
                    },
                    end: {
                        line: 196,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 191,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 194,
                            column: 11
                        },
                        end: {
                            line: 196,
                            column: 5
                        }
                    }
                ],
                line: 191
            },
            "20": {
                loc: {
                    start: {
                        line: 201,
                        column: 6
                    },
                    end: {
                        line: 204,
                        column: 7
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 201,
                            column: 6
                        },
                        end: {
                            line: 204,
                            column: 7
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 201
            },
            "21": {
                loc: {
                    start: {
                        line: 218,
                        column: 23
                    },
                    end: {
                        line: 218,
                        column: 53
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 218,
                            column: 23
                        },
                        end: {
                            line: 218,
                            column: 40
                        }
                    },
                    {
                        start: {
                            line: 218,
                            column: 44
                        },
                        end: {
                            line: 218,
                            column: 53
                        }
                    }
                ],
                line: 218
            },
            "22": {
                loc: {
                    start: {
                        line: 220,
                        column: 2
                    },
                    end: {
                        line: 314,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 220,
                            column: 2
                        },
                        end: {
                            line: 314,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 220
            },
            "23": {
                loc: {
                    start: {
                        line: 241,
                        column: 23
                    },
                    end: {
                        line: 241,
                        column: 54
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 241,
                            column: 38
                        },
                        end: {
                            line: 241,
                            column: 44
                        }
                    },
                    {
                        start: {
                            line: 241,
                            column: 47
                        },
                        end: {
                            line: 241,
                            column: 54
                        }
                    }
                ],
                line: 241
            },
            "24": {
                loc: {
                    start: {
                        line: 245,
                        column: 4
                    },
                    end: {
                        line: 251,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 245,
                            column: 4
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 247,
                            column: 11
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    }
                ],
                line: 245
            },
            "25": {
                loc: {
                    start: {
                        line: 245,
                        column: 8
                    },
                    end: {
                        line: 245,
                        column: 27
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 245,
                            column: 8
                        },
                        end: {
                            line: 245,
                            column: 18
                        }
                    },
                    {
                        start: {
                            line: 245,
                            column: 22
                        },
                        end: {
                            line: 245,
                            column: 27
                        }
                    }
                ],
                line: 245
            },
            "26": {
                loc: {
                    start: {
                        line: 247,
                        column: 11
                    },
                    end: {
                        line: 251,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 247,
                            column: 11
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: 249,
                            column: 11
                        },
                        end: {
                            line: 251,
                            column: 5
                        }
                    }
                ],
                line: 247
            },
            "27": {
                loc: {
                    start: {
                        line: 254,
                        column: 4
                    },
                    end: {
                        line: 260,
                        column: 5
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 254,
                            column: 4
                        },
                        end: {
                            line: 260,
                            column: 5
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 254
            },
            "28": {
                loc: {
                    start: {
                        line: 254,
                        column: 8
                    },
                    end: {
                        line: 254,
                        column: 58
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 254,
                            column: 8
                        },
                        end: {
                            line: 254,
                            column: 20
                        }
                    },
                    {
                        start: {
                            line: 254,
                            column: 25
                        },
                        end: {
                            line: 254,
                            column: 41
                        }
                    },
                    {
                        start: {
                            line: 254,
                            column: 45
                        },
                        end: {
                            line: 254,
                            column: 57
                        }
                    }
                ],
                line: 254
            },
            "29": {
                loc: {
                    start: {
                        line: 268,
                        column: 11
                    },
                    end: {
                        line: 310,
                        column: 11
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 268,
                            column: 11
                        },
                        end: {
                            line: 268,
                            column: 23
                        }
                    },
                    {
                        start: {
                            line: 268,
                            column: 28
                        },
                        end: {
                            line: 268,
                            column: 44
                        }
                    },
                    {
                        start: {
                            line: 268,
                            column: 48
                        },
                        end: {
                            line: 268,
                            column: 60
                        }
                    },
                    {
                        start: {
                            line: 269,
                            column: 12
                        },
                        end: {
                            line: 309,
                            column: 32
                        }
                    }
                ],
                line: 268
            },
            "30": {
                loc: {
                    start: {
                        line: 279,
                        column: 35
                    },
                    end: {
                        line: 279,
                        column: 58
                    }
                },
                type: "binary-expr",
                locations: [
                    {
                        start: {
                            line: 279,
                            column: 35
                        },
                        end: {
                            line: 279,
                            column: 45
                        }
                    },
                    {
                        start: {
                            line: 279,
                            column: 49
                        },
                        end: {
                            line: 279,
                            column: 58
                        }
                    }
                ],
                line: 279
            },
            "31": {
                loc: {
                    start: {
                        line: 292,
                        column: 24
                    },
                    end: {
                        line: 292,
                        column: 90
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 292,
                            column: 37
                        },
                        end: {
                            line: 292,
                            column: 67
                        }
                    },
                    {
                        start: {
                            line: 292,
                            column: 70
                        },
                        end: {
                            line: 292,
                            column: 90
                        }
                    }
                ],
                line: 292
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0,
            "13": 0,
            "14": 0,
            "15": 0,
            "16": 0,
            "17": 0,
            "18": 0,
            "19": 0,
            "20": 0,
            "21": 0,
            "22": 0,
            "23": 0,
            "24": 0,
            "25": 0,
            "26": 0,
            "27": 0,
            "28": 0,
            "29": 0,
            "30": 0,
            "31": 0,
            "32": 0,
            "33": 0,
            "34": 0,
            "35": 0,
            "36": 0,
            "37": 0,
            "38": 0,
            "39": 0,
            "40": 0,
            "41": 0,
            "42": 0,
            "43": 0,
            "44": 0,
            "45": 0,
            "46": 0,
            "47": 0,
            "48": 0,
            "49": 0,
            "50": 0,
            "51": 0,
            "52": 0,
            "53": 0,
            "54": 0,
            "55": 0,
            "56": 0,
            "57": 0,
            "58": 0,
            "59": 0,
            "60": 0,
            "61": 0,
            "62": 0,
            "63": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0
        },
        b: {
            "0": [
                0
            ],
            "1": [
                0
            ],
            "2": [
                0,
                0
            ],
            "3": [
                0
            ],
            "4": [
                0
            ],
            "5": [
                0,
                0
            ],
            "6": [
                0,
                0
            ],
            "7": [
                0,
                0
            ],
            "8": [
                0,
                0
            ],
            "9": [
                0,
                0
            ],
            "10": [
                0,
                0
            ],
            "11": [
                0,
                0
            ],
            "12": [
                0,
                0
            ],
            "13": [
                0,
                0
            ],
            "14": [
                0,
                0
            ],
            "15": [
                0,
                0
            ],
            "16": [
                0,
                0
            ],
            "17": [
                0,
                0
            ],
            "18": [
                0,
                0
            ],
            "19": [
                0,
                0
            ],
            "20": [
                0,
                0
            ],
            "21": [
                0,
                0
            ],
            "22": [
                0,
                0
            ],
            "23": [
                0,
                0
            ],
            "24": [
                0,
                0
            ],
            "25": [
                0,
                0
            ],
            "26": [
                0,
                0
            ],
            "27": [
                0,
                0
            ],
            "28": [
                0,
                0,
                0
            ],
            "29": [
                0,
                0,
                0,
                0
            ],
            "30": [
                0,
                0
            ],
            "31": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "07e7abcc1d9f196d2ac5b7463687882d6b942e86"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_19j15inqim = function cov_19j15inqim() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}


cov_19j15inqim();










function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r1) {
            o = !0, n = r1;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}


// Simple wrapper component similar to PickerSelect's approach
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var ListBoxElement = (cov_19j15inqim().s[0]++, /*#__PURE__*/ react.forwardRef(function ListBoxElement(props, forwardedRef) {
    cov_19j15inqim().f[0]++;
    cov_19j15inqim().s[1]++;
    return /*#__PURE__*/ react.createElement("ul", _extends({}, props, {
        ref: forwardedRef
    }));
}));
cov_19j15inqim().s[2]++;
var BricksNextListBox = function BricksNextListBox(_ref) {
    var children = _ref.children, listBoxId = _ref.listBoxId, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? (cov_19j15inqim().b[0][0]++, "suggestions") : _ref$ariaLabel, _ref$size = _ref.size, size = _ref$size === void 0 ? (cov_19j15inqim().b[1][0]++, "medium") : _ref$size;
    cov_19j15inqim().f[1]++;
    // Map size to border radius tokens that match TextInput
    var borderRadiusMap = (cov_19j15inqim().s[3]++, {
        small: "$7x",
        medium: "$9x",
        large: "$12x"
    });
    var borderRadius = (cov_19j15inqim().s[4]++, (cov_19j15inqim().b[2][0]++, borderRadiusMap[size]) || (cov_19j15inqim().b[2][1]++, "$9x"));
    cov_19j15inqim().s[5]++;
    return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
        borderBottomLeftRadius: borderRadius,
        borderBottomRightRadius: borderRadius,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        maxHeight: 450,
        position: "absolute",
        top: "100%",
        left: 0,
        right: 0,
        marginTop: -1.5,
        borderLeftWidth: 1.5,
        borderRightWidth: 1.5,
        borderBottomWidth: 1.5,
        borderTopWidth: 0,
        borderStyle: "solid",
        borderColor: "$borderAccentBrand",
        backgroundColor: "$backgroundPrimary",
        overflow: "hidden",
        zIndex: 1000
    }, /*#__PURE__*/ react.createElement(ListBoxElement, {
        role: "listbox",
        "aria-label": ariaLabel,
        id: listBoxId,
        style: {
            padding: 0,
            margin: 0,
            listStyleType: "none"
        }
    }, children));
};
cov_19j15inqim().s[6]++;
var AutocompleteInput = function AutocompleteInput(_ref2) {
    var id = _ref2.id, label = _ref2.label, hideLabel = _ref2.hideLabel, placeholder = _ref2.placeholder, disabled = _ref2.disabled, items = _ref2.items, searchTerm = _ref2.searchTerm, onSearchChange = _ref2.onSearchChange, onItemSelect = _ref2.onItemSelect, renderItem = _ref2.renderItem, suffix = _ref2.suffix, customAction = _ref2.customAction, _ref2$listBoxId = _ref2.listBoxId, listBoxId = _ref2$listBoxId === void 0 ? (cov_19j15inqim().b[3][0]++, "autocomplete-listbox") : _ref2$listBoxId, listBoxAriaLabel = _ref2.listBoxAriaLabel, onEscape = _ref2.onEscape, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (cov_19j15inqim().b[4][0]++, "medium") : _ref2$size, supportText = _ref2.supportText, errorText = _ref2.errorText, invalid = _ref2.invalid, required = _ref2.required, externalInputRef = _ref2.inputRef;
    cov_19j15inqim().f[2]++;
    var _ref3 = (cov_19j15inqim().s[7]++, (0,react.useState)(undefined)), _ref4 = _slicedToArray(_ref3, 2), selectedIndex = _ref4[0], setSelectedIndex = _ref4[1];
    var _ref5 = (cov_19j15inqim().s[8]++, (0,react.useState)(false)), _ref6 = _slicedToArray(_ref5, 2), isFocused = _ref6[0], setIsFocused = _ref6[1];
    var useBricksNext = (cov_19j15inqim().s[9]++, true);
    var internalInputRef = (cov_19j15inqim().s[10]++, (0,react.useRef)(null));
    var inputRef = (cov_19j15inqim().s[11]++, (cov_19j15inqim().b[5][0]++, externalInputRef) || (cov_19j15inqim().b[5][1]++, internalInputRef));
    // Reset selection when items change to prevent stale index
    cov_19j15inqim().s[12]++;
    (0,react.useEffect)(function() {
        cov_19j15inqim().f[3]++;
        cov_19j15inqim().s[13]++;
        if ((cov_19j15inqim().b[7][0]++, selectedIndex !== undefined) && (cov_19j15inqim().b[7][1]++, selectedIndex >= items.length)) {
            cov_19j15inqim().b[6][0]++;
            cov_19j15inqim().s[14]++;
            setSelectedIndex(undefined);
        } else {
            cov_19j15inqim().b[6][1]++;
        }
    }, [
        items,
        selectedIndex
    ]);
    var handleItemSelect = (cov_19j15inqim().s[15]++, (0,react.useCallback)(function(item) {
        cov_19j15inqim().f[4]++;
        cov_19j15inqim().s[16]++;
        return function() {
            var _inputRef$current;
            cov_19j15inqim().f[5]++;
            cov_19j15inqim().s[17]++;
            onItemSelect(item);
            cov_19j15inqim().s[18]++;
            (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.blur();
        };
    }, [
        onItemSelect,
        inputRef
    ]));
    cov_19j15inqim().s[19]++;
    var onKeyDown = function onKeyDown(e) {
        cov_19j15inqim().f[6]++;
        cov_19j15inqim().s[20]++;
        if (e.key === "ArrowDown") {
            cov_19j15inqim().b[8][0]++;
            cov_19j15inqim().s[21]++;
            e.preventDefault();
            cov_19j15inqim().s[22]++;
            if (items.length > 0) {
                cov_19j15inqim().b[9][0]++;
                var newSelectedIndex = (cov_19j15inqim().s[23]++, (cov_19j15inqim().b[11][0]++, selectedIndex === undefined) || (cov_19j15inqim().b[11][1]++, selectedIndex === items.length - 1) ? (cov_19j15inqim().b[10][0]++, 0) : (cov_19j15inqim().b[10][1]++, selectedIndex + 1));
                cov_19j15inqim().s[24]++;
                setSelectedIndex(newSelectedIndex);
            } else {
                cov_19j15inqim().b[9][1]++;
            }
        } else {
            cov_19j15inqim().b[8][1]++;
            cov_19j15inqim().s[25]++;
            if (e.key === "ArrowUp") {
                cov_19j15inqim().b[12][0]++;
                cov_19j15inqim().s[26]++;
                e.preventDefault();
                cov_19j15inqim().s[27]++;
                if (items.length > 0) {
                    cov_19j15inqim().b[13][0]++;
                    var _newSelectedIndex = (cov_19j15inqim().s[28]++, (cov_19j15inqim().b[15][0]++, selectedIndex === undefined) || (cov_19j15inqim().b[15][1]++, selectedIndex === 0) ? (cov_19j15inqim().b[14][0]++, items.length - 1) : (cov_19j15inqim().b[14][1]++, selectedIndex - 1));
                    cov_19j15inqim().s[29]++;
                    setSelectedIndex(_newSelectedIndex);
                } else {
                    cov_19j15inqim().b[13][1]++;
                }
            } else {
                cov_19j15inqim().b[12][1]++;
                cov_19j15inqim().s[30]++;
                if (e.key === "Enter") {
                    cov_19j15inqim().b[16][0]++;
                    cov_19j15inqim().s[31]++;
                    e.preventDefault();
                    cov_19j15inqim().s[32]++;
                    if ((cov_19j15inqim().b[18][0]++, selectedIndex !== undefined) && (cov_19j15inqim().b[18][1]++, items[selectedIndex])) {
                        var _inputRef$current2;
                        cov_19j15inqim().b[17][0]++;
                        cov_19j15inqim().s[33]++;
                        onItemSelect(items[selectedIndex]);
                        cov_19j15inqim().s[34]++;
                        (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
                    } else {
                        cov_19j15inqim().b[17][1]++;
                    }
                } else {
                    cov_19j15inqim().b[16][1]++;
                    cov_19j15inqim().s[35]++;
                    if (e.key === "Escape") {
                        cov_19j15inqim().b[19][0]++;
                        cov_19j15inqim().s[36]++;
                        setSelectedIndex(undefined);
                        cov_19j15inqim().s[37]++;
                        onEscape === null || onEscape === void 0 || onEscape();
                    } else {
                        cov_19j15inqim().b[19][1]++;
                        cov_19j15inqim().s[38]++;
                        setSelectedIndex(undefined);
                    }
                }
            }
        }
    };
    var handleContainerBlur = (cov_19j15inqim().s[39]++, (0,react.useCallback)(function(e) {
        cov_19j15inqim().f[7]++;
        cov_19j15inqim().s[40]++;
        if (!e.currentTarget.contains(e.relatedTarget)) {
            cov_19j15inqim().b[20][0]++;
            cov_19j15inqim().s[41]++;
            setIsFocused(false);
            cov_19j15inqim().s[42]++;
            onBlur === null || onBlur === void 0 || onBlur();
        } else {
            cov_19j15inqim().b[20][1]++;
        }
    }, [
        onBlur
    ]));
    var handleContainerFocus = (cov_19j15inqim().s[43]++, (0,react.useCallback)(function() {
        cov_19j15inqim().f[8]++;
        cov_19j15inqim().s[44]++;
        setIsFocused(true);
        cov_19j15inqim().s[45]++;
        onFocus === null || onFocus === void 0 || onFocus();
    }, [
        onFocus
    ]));
    var handleMouseDown = (cov_19j15inqim().s[46]++, (0,react.useCallback)(function(e) {
        cov_19j15inqim().f[9]++;
        cov_19j15inqim().s[47]++;
        e.preventDefault();
    }, []));
    var showDropdown = (cov_19j15inqim().s[48]++, (cov_19j15inqim().b[21][0]++, searchTerm !== "") && (cov_19j15inqim().b[21][1]++, isFocused));
    cov_19j15inqim().s[49]++;
    if (useBricksNext) {
        cov_19j15inqim().b[22][0]++;
        var textInputProps = (cov_19j15inqim().s[50]++, {
            id: id,
            placeholder: placeholder,
            disabled: disabled,
            value: searchTerm,
            onChangeText: function onChangeText(text) {
                cov_19j15inqim().f[10]++;
                var syntheticEvent = (cov_19j15inqim().s[51]++, {
                    target: {
                        value: text
                    }
                });
                cov_19j15inqim().s[52]++;
                onSearchChange(syntheticEvent);
            },
            onKeyPress: onKeyDown,
            size: size,
            supportText: supportText,
            errorText: errorText,
            invalid: invalid,
            required: required,
            autoComplete: "off",
            role: "combobox",
            "aria-autocomplete": "list",
            "aria-expanded": showDropdown ? (cov_19j15inqim().b[23][0]++, "true") : (cov_19j15inqim().b[23][1]++, "false"),
            "aria-controls": listBoxId
        });
        cov_19j15inqim().s[53]++;
        if ((cov_19j15inqim().b[25][0]++, !hideLabel) && (cov_19j15inqim().b[25][1]++, label)) {
            cov_19j15inqim().b[24][0]++;
            cov_19j15inqim().s[54]++;
            textInputProps.title = label;
        } else {
            cov_19j15inqim().b[24][1]++;
            cov_19j15inqim().s[55]++;
            if (label) {
                cov_19j15inqim().b[26][0]++;
                cov_19j15inqim().s[56]++;
                textInputProps.ariaLabel = label;
            } else {
                cov_19j15inqim().b[26][1]++;
                cov_19j15inqim().s[57]++;
                textInputProps.ariaLabel = "Search input";
            }
        }
        // Modify border styling when dropdown is showing AND there are items or customAction to display
        cov_19j15inqim().s[58]++;
        if ((cov_19j15inqim().b[28][0]++, showDropdown) && ((cov_19j15inqim().b[28][1]++, items.length > 0) || (cov_19j15inqim().b[28][2]++, customAction))) {
            cov_19j15inqim().b[27][0]++;
            cov_19j15inqim().s[59]++;
            textInputProps.frameProps = {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomWidth: 0
            };
        } else {
            cov_19j15inqim().b[27][1]++;
        }
        cov_19j15inqim().s[60]++;
        return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            onFocus: handleContainerFocus,
            onBlur: handleContainerBlur
        }, /*#__PURE__*/ react.createElement(Box/* Box */.x, {
            position: "relative"
        }, /*#__PURE__*/ react.createElement(TextInput/* TextInput */.o, _extends({}, textInputProps, {
            ref: inputRef
        }), suffix), (cov_19j15inqim().b[29][0]++, showDropdown) && ((cov_19j15inqim().b[29][1]++, items.length > 0) || (cov_19j15inqim().b[29][2]++, customAction)) && (cov_19j15inqim().b[29][3]++, /*#__PURE__*/ react.createElement(BricksNextListBox, {
            listBoxId: listBoxId,
            ariaLabel: listBoxAriaLabel,
            size: size
        }, items.map(function(item, index) {
            cov_19j15inqim().f[11]++;
            var isSelected = (cov_19j15inqim().s[61]++, selectedIndex === index);
            cov_19j15inqim().s[62]++;
            return /*#__PURE__*/ react.createElement(Box/* Box */.x, {
                tag: "li",
                id: "autocomplete-options",
                key: item.id,
                role: "option",
                "aria-selected": (cov_19j15inqim().b[30][0]++, isSelected) || (cov_19j15inqim().b[30][1]++, undefined),
                overflow: "hidden"
            }, /*#__PURE__*/ react.createElement(PressableBox/* PressableBox */.K, {
                zIndex: 2,
                justifyContent: "flex-start",
                onMouseDown: handleMouseDown,
                analyticsName: "",
                "aria-label": item.ariaLabel,
                animation: "accelerateDecelerateFastest",
                height: "100%",
                width: "100%",
                backgroundColor: isSelected ? (cov_19j15inqim().b[31][0]++, "$backgroundStateHoverPrimary") : (cov_19j15inqim().b[31][1]++, "$backgroundPrimary"),
                hoverStyle: {
                    backgroundColor: "$backgroundStateHoverPrimary"
                },
                onPress: handleItemSelect(item),
                pressStyle: {
                    scale: 0.98
                },
                padding: 10
            }, renderItem(item, isSelected)));
        }), customAction))));
    } else {
        cov_19j15inqim().b[22][1]++;
    }
    cov_19j15inqim().s[63]++;
    return null;
};
/* harmony default export */ var AutocompleteInput_AutocompleteInput = (AutocompleteInput); //# sourceMappingURL=AutocompleteInput.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/cinderblocks/es/core/AutocompleteInput/index.mjs
function cov_1virlom3ih() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/index.ts";
    var hash = "a288b201af162c8b65bc24e8c5d4f5369d94e5e0";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/core/AutocompleteInput/index.ts",
        statementMap: {},
        fnMap: {},
        branchMap: {},
        s: {},
        f: {},
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "a288b201af162c8b65bc24e8c5d4f5369d94e5e0"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_1virlom3ih = function cov_1virlom3ih() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1virlom3ih();
 //# sourceMappingURL=index.mjs.map


/***/ }),

/***/ 99835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ buildAutocompleteUrl; },
/* harmony export */   "MF": function() { return /* binding */ ALLOWED_TYPES; },
/* harmony export */   "dl": function() { return /* binding */ buildPlacesUrl; },
/* harmony export */   "h_": function() { return /* binding */ generateGoogleMapsSessionToken; },
/* harmony export */   "wC": function() { return /* binding */ buildCityAutocompleteUrl; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92222);
/* harmony import */ var core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_number_max_safe_integer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44363);
/* harmony import */ var core_js_modules_es_number_max_safe_integer_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_number_max_safe_integer_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39714);
/* harmony import */ var core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_to_string_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _globals_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47254);
function cov_1gofhce09t() {
    var path = "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/googleMaps.ts";
    var hash = "7c25e13ab78b09b6b1e39160a4a3378ec3c3fb23";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/home/runner/_work/code/code/js/packages/cinderblocks/src/helpers/googleMaps.ts",
        statementMap: {
            "0": {
                start: {
                    line: 3,
                    column: 26
                },
                end: {
                    line: 5,
                    column: 49
                }
            },
            "1": {
                start: {
                    line: 7,
                    column: 29
                },
                end: {
                    line: 7,
                    column: 81
                }
            },
            "2": {
                start: {
                    line: 9,
                    column: 46
                },
                end: {
                    line: 11,
                    column: 1
                }
            },
            "3": {
                start: {
                    line: 10,
                    column: 2
                },
                end: {
                    line: 10,
                    column: 72
                }
            },
            "4": {
                start: {
                    line: 13,
                    column: 36
                },
                end: {
                    line: 15,
                    column: 1
                }
            },
            "5": {
                start: {
                    line: 14,
                    column: 2
                },
                end: {
                    line: 14,
                    column: 89
                }
            },
            "6": {
                start: {
                    line: 17,
                    column: 40
                },
                end: {
                    line: 21,
                    column: 1
                }
            },
            "7": {
                start: {
                    line: 18,
                    column: 2
                },
                end: {
                    line: 20,
                    column: 22
                }
            },
            "8": {
                start: {
                    line: 23,
                    column: 30
                },
                end: {
                    line: 39,
                    column: 1
                }
            },
            "9": {
                start: {
                    line: 34,
                    column: 18
                },
                end: {
                    line: 34,
                    column: 46
                }
            },
            "10": {
                start: {
                    line: 35,
                    column: 2
                },
                end: {
                    line: 37,
                    column: 3
                }
            },
            "11": {
                start: {
                    line: 36,
                    column: 4
                },
                end: {
                    line: 36,
                    column: 53
                }
            },
            "12": {
                start: {
                    line: 38,
                    column: 2
                },
                end: {
                    line: 38,
                    column: 70
                }
            }
        },
        fnMap: {
            "0": {
                name: "(anonymous_0)",
                decl: {
                    start: {
                        line: 9,
                        column: 46
                    },
                    end: {
                        line: 9,
                        column: 47
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 52
                    },
                    end: {
                        line: 11,
                        column: 1
                    }
                },
                line: 9
            },
            "1": {
                name: "(anonymous_1)",
                decl: {
                    start: {
                        line: 13,
                        column: 36
                    },
                    end: {
                        line: 13,
                        column: 37
                    }
                },
                loc: {
                    start: {
                        line: 13,
                        column: 77
                    },
                    end: {
                        line: 15,
                        column: 1
                    }
                },
                line: 13
            },
            "2": {
                name: "(anonymous_2)",
                decl: {
                    start: {
                        line: 17,
                        column: 40
                    },
                    end: {
                        line: 17,
                        column: 41
                    }
                },
                loc: {
                    start: {
                        line: 17,
                        column: 81
                    },
                    end: {
                        line: 21,
                        column: 1
                    }
                },
                line: 17
            },
            "3": {
                name: "(anonymous_3)",
                decl: {
                    start: {
                        line: 23,
                        column: 30
                    },
                    end: {
                        line: 23,
                        column: 31
                    }
                },
                loc: {
                    start: {
                        line: 33,
                        column: 6
                    },
                    end: {
                        line: 39,
                        column: 1
                    }
                },
                line: 33
            }
        },
        branchMap: {
            "0": {
                loc: {
                    start: {
                        line: 3,
                        column: 26
                    },
                    end: {
                        line: 5,
                        column: 49
                    }
                },
                type: "cond-expr",
                locations: [
                    {
                        start: {
                            line: 4,
                            column: 4
                        },
                        end: {
                            line: 4,
                            column: 21
                        }
                    },
                    {
                        start: {
                            line: 5,
                            column: 4
                        },
                        end: {
                            line: 5,
                            column: 49
                        }
                    }
                ],
                line: 3
            },
            "1": {
                loc: {
                    start: {
                        line: 35,
                        column: 2
                    },
                    end: {
                        line: 37,
                        column: 3
                    }
                },
                type: "if",
                locations: [
                    {
                        start: {
                            line: 35,
                            column: 2
                        },
                        end: {
                            line: 37,
                            column: 3
                        }
                    },
                    {
                        start: {
                            line: undefined,
                            column: undefined
                        },
                        end: {
                            line: undefined,
                            column: undefined
                        }
                    }
                ],
                line: 35
            }
        },
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "11": 0,
            "12": 0
        },
        f: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0
        },
        b: {
            "0": [
                0,
                0
            ],
            "1": [
                0,
                0
            ]
        },
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "7c25e13ab78b09b6b1e39160a4a3378ec3c3fb23"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        // @ts-ignore
        cov_1gofhce09t = function cov_1gofhce09t() {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_1gofhce09t();





var ADDRESS_INPUT_URL = (cov_1gofhce09t().s[0]++, (0,_globals_mjs__WEBPACK_IMPORTED_MODULE_4__/* .isProductionEnv */ .n5)() ? (cov_1gofhce09t().b[0][0]++, "/_address-input") : (cov_1gofhce09t().b[0][1]++, "https://demo.simplersell.com/_address-input"));
var ALLOWED_TYPES = (cov_1gofhce09t().s[1]++, [
    "street_address",
    "premise",
    "subpremise",
    "route"
]);
cov_1gofhce09t().s[2]++;
var generateGoogleMapsSessionToken = function generateGoogleMapsSessionToken() {
    cov_1gofhce09t().f[0]++;
    cov_1gofhce09t().s[3]++;
    return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString();
};
cov_1gofhce09t().s[4]++;
var buildAutocompleteUrl = function buildAutocompleteUrl(query, sessionToken) {
    cov_1gofhce09t().f[1]++;
    cov_1gofhce09t().s[5]++;
    return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(sessionToken, "&query=").concat(query);
};
cov_1gofhce09t().s[6]++;
var buildCityAutocompleteUrl = function buildCityAutocompleteUrl(query, sessionToken) {
    cov_1gofhce09t().f[2]++;
    cov_1gofhce09t().s[7]++;
    return "".concat(ADDRESS_INPUT_URL, "/autocomplete?sessionToken=").concat(sessionToken, "&query=").concat(encodeURIComponent(query), "&types=(regions)");
};
cov_1gofhce09t().s[8]++;
var buildPlacesUrl = function buildPlacesUrl(_ref) {
    var source = _ref.source, placeId = _ref.placeId, addressToken = _ref.addressToken, sessionToken = _ref.sessionToken;
    cov_1gofhce09t().f[3]++;
    var baseUrl = (cov_1gofhce09t().s[9]++, "".concat(ADDRESS_INPUT_URL, "/place"));
    cov_1gofhce09t().s[10]++;
    if (source === "casa") {
        cov_1gofhce09t().b[1][0]++;
        cov_1gofhce09t().s[11]++;
        return baseUrl + "?addressToken=".concat(addressToken);
    } else {
        cov_1gofhce09t().b[1][1]++;
    }
    cov_1gofhce09t().s[12]++;
    return baseUrl + "?sessionToken=".concat(sessionToken, "&placeId=").concat(placeId);
}; //# sourceMappingURL=googleMaps.mjs.map


/***/ }),

/***/ 77969:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IconCircleCheckFilled; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33733);
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z", "key": "svg-0" }]];
const IconCircleCheckFilled = (0,_createReactComponent_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("filled", "circle-check-filled", "CircleCheckFilled", __iconNode);


//# sourceMappingURL=IconCircleCheckFilled.mjs.map


/***/ })

}]);